/*
  Studio Pro By Charlot V2 · le configurateur avec prix HT au centime (/pages/cadeau-entreprise, gabarit studio-pro-v2).

  Donnees posees par la section Liquid dans <script id="sp2-donnees"> : plantes, pots et etiquettes
  (variante, SKU, prix TTC en centimes, stock), photos de reference pour l'apercu de l'etiquette,
  adresse du script de reception (reception) et du serveur rapide des devis (worker, Worker Cloudflare : les devis y
  partent d'abord, le script en repli). Modules charges avant ce fichier :
    StudioCalcul    le calcul du devis, le meme que le script qui recoit la demande (REGLES reglables)
    StudioAdresses  lecture et controle du fichier des destinataires (SheetJS charge a la demande)
    StudioEtiquette apercu de l'etiquette par l'API d'impression, pose sur la vraie photo

  Principe de Charles : RIEN N'EST BLOQUANT. Seuls la societe, le nom et un email valide sont demandes.
  Ce qui sort du cadre (date proche, stock, 100 pieces et plus, hors France) part quand
  meme, « notre equipe vous confirme sous 24 h ouvrees », et remplit aConfirmer.
  Reglage reception_url vide : mode essai, rien n'est envoye, la demande s'affiche dans la console.
*/
(function () {
  "use strict";
  const racine = document.getElementById("studio-pro-v2");
  if (!racine) return;
  let DON = null;
  try { DON = JSON.parse(document.getElementById("sp2-donnees").textContent); }
  catch (e) { console.error("Studio Pro V2 : données de la page illisibles", e); return; }
  const C = window.StudioCalcul, A = window.StudioAdresses, E = window.StudioEtiquette;
  if (!C) { console.error("Studio Pro V2 : module de calcul absent"); return; }

  // Le theme anime ce qui passe sous la ligne de flottaison (snippet bc-animations, qui exclut #studio-pro
  // mais pas cette page). La page pro a ses propres animations et redessine son contenu : un element
  // marque par le theme puis redessine resterait invisible. On retire donc ces classes des qu'elles arrivent.
  const sansAnimTheme = el => { if (el.classList && (el.classList.contains("bc-anim") || el.classList.contains("bc-anim-pret"))) el.classList.remove("bc-anim", "bc-anim-pret"); };
  racine.querySelectorAll(".bc-anim").forEach(sansAnimTheme);
  if ("MutationObserver" in window) new MutationObserver(ms => ms.forEach(m => sansAnimTheme(m.target))).observe(racine, { attributes: true, attributeFilter: ["class"], subtree: true });

  // ------------------------------------------------ les regles, toutes lues dans StudioCalcul.REGLES
  const RG = C.REGLES;
  // offre du 19/10/2026 : étiquette offerte jusqu'au 15/11 (REGLES.etiquetteOfferte) ; l'horloge du navigateur décide de
  // l'affichage, le serveur décide du prix (à la réception de la demande, 30 minutes de grâce après minuit)
  const OFFRE = RG.etiquetteOfferte || null;
  const offreEtiquette = () => !!(OFFRE && C.etiquetteOfferte && C.etiquetteOfferte(Date.now()));
  const MIN_ENVOI = RG.minimum || 1;                        // pieces pour envoyer une demande
  const MIN_PRO = RG.minimumPro || RG.minimum || 10;         // pieces pour le tarif pro
  const BASCULE = RG.bascule || 100;                        // des ce seuil : a confirmer par l'equipe (payable jusqu'a 99, decision du 30/09)
  const VIREMENT_DES = RG.virementDes || MIN_PRO;           // sous ce seuil : carte seulement
  const JOURS_MINI = RG.joursMini || 7;                     // une semaine entre le reglement et l'expedition
  const PREMIER = RG.paliers[0] || { des: MIN_PRO, taux: 0 };
  const EMAIL = DON.email || "business@bycharlot.com";
  const MAX_FICHIERS = 22 * 1024 * 1024;
  const XLSX_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  // ------------------------------------------------ outils
  const $ = (s, z) => (z || racine).querySelector(s);
  const $$ = (s, z) => [...(z || racine).querySelectorAll(s)];
  const ech = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const eur = c => C.euros(c);
  const eurHT = c => C.euros(c) + " HT";
  const eurRond = c => C.euros(c).replace(/,00(?=\s)/, "") + " HT";          // 500 € HT plutot que 500,00 € HT
  const pl = (n, s, p) => (n > 1 ? (p || s + "s") : s);
  const pct = t => String(t).replace(".", ",") + "\u00a0%";                     // 11,5 %
  const calme = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const emailValide = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || "").trim());
  const nomCourt = n => String(n || "").replace(/^(le |la |les |l['’])/i, "");
  const debut = Date.now();

  // ------------------------------------------------ la provenance de la visite (mesure pub, 01/10/2026)
  // Lue une fois, a l'arrivee, dans l'adresse de la page : les UTM et le site d'origine (nom du site seulement). Les
  // identifiants de clic des regies (gclid, gbraid, wbraid, msclkid, fbclid) ne partent avec la demande QUE si le visiteur
  // accepte les cookies marketing : Shopify.customerPrivacy.marketingAllowed(), lu au moment de l'envoi (le bandeau est
  // souvent accepte apres l'arrivee). Rien n'est stocke dans le navigateur : la source vit le temps de la page et part
  // dans le champ « source » de la demande (le script la range avec la demande et l'ecrit dans la feuille de suivi).
  const PROVENANCE = (() => {
    let p = null;
    try { p = new URLSearchParams(location.search); } catch (e) { p = null; }
    // valeurs courtes et propres : ni accolade ni guillemet (le script relit la source dans le debut de la demande)
    const net = v => String(v == null ? "" : v).replace(/[^\p{L}\p{N} ._~:/|+@,()'-]/gu, "").replace(/\s+/g, " ").trim().slice(0, 150);
    const lire = cles => cles.reduce((o, k) => { const v = p ? net(p.get(k)) : ""; if (v) o[k] = v; return o; }, {});
    let origine = "";
    try { if (document.referrer) origine = net(new URL(document.referrer).hostname.replace(/^www\./, "")); } catch (e) { origine = ""; }
    return { utm: lire(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]), clics: lire(["gclid", "gbraid", "wbraid", "msclkid", "fbclid"]), origine };
  })();
  const accordMarketing = () => {
    try { const cp = window.Shopify && window.Shopify.customerPrivacy; return !!(cp && typeof cp.marketingAllowed === "function" && cp.marketingAllowed()); }
    catch (e) { return false; }
  };
  // l'API de consentement de Shopify est chargee par le bandeau ; sinon on la demande, sans attendre (un identifiant de clic seulement)
  if (Object.keys(PROVENANCE.clics).length) {
    try { const sh = window.Shopify; if (sh && !sh.customerPrivacy && typeof sh.loadFeatures === "function") sh.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {}); }
    catch (e) { /* sans l'API : aucun identifiant de clic ne part */ }
  }
  const source = () => Object.assign({}, PROVENANCE.utm, PROVENANCE.origine ? { origine: PROVENANCE.origine } : {}, accordMarketing() ? PROVENANCE.clics : {});

  // ------------------------------------------------ le catalogue
  // comme la fiche produit de la boutique : une variante marquee custom.variantOutOfStock n'est jamais proposee
  const PLANTES = (DON.plantes || []).filter(p => p && p.variantId && p.dispo !== false && !p.masque && p.prix > 0 && p.stock > 0);
  const POTS = (DON.pots || []).filter(p => p && p.variantId && !p.masque && p.prix > 0 && p.stock > 0);
  const ETIQ = DON.etiquettes || {};
  const TAILLES = [
    { t: "XS", nom: "Petites", court: "petite", h: "environ 15\u00a0cm", pot: "pot\u00a0⌀\u00a08\u00a0cm", usage: "une attention" },
    { t: "S", nom: "Standards", court: "standard", h: "20 à 30\u00a0cm", pot: "pot\u00a0⌀\u00a010\u00a0cm", usage: "sur un bureau" },
    { t: "M", nom: "Grandes", court: "grande", h: "environ 50\u00a0cm", pot: "pot\u00a0⌀\u00a015\u00a0cm", usage: "pour un accueil" }
  ].map(x => Object.assign(x, { detail: `${x.h} · ${x.pot}` })).filter(x => PLANTES.some(p => p.t === x.t));
  const taille = t => TAILLES.find(x => x.t === t) || { t, nom: t, court: t, detail: "" };
  const plante = id => PLANTES.find(p => p.variantId === id) || null;
  const pot = id => POTS.find(p => p.variantId === id) || null;
  const STOCK_MIN = RG.stockMinAffiche || 10;
  let PLANTES_VUES = PLANTES.filter(p => p.stock >= STOCK_MIN);                   // la grille, les substituts (refaite au stock Factory)
  const potsTousDe = t => POTS.filter(p => p.t === t);                              // pots assortis : tout le stock de la taille
  const EN_AVANT = RG.potsMisEnAvant || [];                                          // B2B : ces pots d'abord (petite taille)
  const rangAvant = p => { const i = EN_AVANT.indexOf(p.sku); return i < 0 ? EN_AVANT.length : i; };
  const potsDe = t => POTS.filter(p => p.t === t && p.stock >= STOCK_MIN).sort((a, b) => rangAvant(a) - rangAvant(b));   // les pots que l'on montre
  const GRANDE_SERIE = RG.pastilleStockMin || Infinity;
  const htPot = p => Math.round((p.prix * 100) / (100 + RG.tvaPot));
  // le prix de la plante est deja affiche : sur un pot, seulement ce qu'il ajoute au moins cher de la taille
  const supplement = x => { const vus = potsDe(x.t); return vus.length ? Math.max(0, htPot(x) - Math.min(...vus.map(htPot))) : 0; };
  const tuilePot = x => `<button type="button" class="pot" data-pot="${x.variantId}" title="${ech(x.nom)}"><img src="${ech(x.img)}" alt="" loading="lazy" width="240" height="240">`
    + (x.stock > GRANDE_SERIE ? `<span class="gs">Grande série</span>` : "") + (supplement(x) ? `<span class="p">+ ${eur(supplement(x))}</span>` : "") + `<span class="s" hidden></span></button>`;
  const etiquettePot = x => `${x.nom}` + (supplement(x) ? `, ${eurHT(supplement(x))} de plus` : "") + (x.stock > GRANDE_SERIE ? ", grande série" : "");
  const potMoinsCher = t => potsTousDe(t).reduce((a, b) => (!a || b.prix < a.prix || (b.prix === a.prix && b.stock > a.stock) ? b : a), null);
  const unite = (p, po) => C.unitaireHT(p.prix, po ? po.prix : 0);       // centimes HT, plante + pot

  // le mix compose par l'equipe : styles tires des etiquettes (tags) reelles des plantes, prix au median de la taille
  const STYLES = [
    { id: "robustes", nom: "Robustes et faciles", tags: ["Plantes facile d'entretien"] },
    { id: "succulentes", nom: "Cactus et succulentes", tags: ["Cactus", "Succulentes", "Euphorbes"] },
    { id: "colorees", nom: "Feuillages colorés", tags: ["colorées"] },
    { id: "vertes", nom: "Plantes vertes", tags: ["Plantes et palmiers"] }
  ];
  const styleDe = id => STYLES.find(x => x.id === id) || null;
  const stylesDe = t => STYLES.filter(st => PLANTES.filter(p => p.t === t && (p.tags || []).some(g => st.tags.includes(g))).length >= 2);
  // mediane basse (un vrai prix du catalogue), la meme que le script qui chiffre le mix
  const mediane = liste => { const a = liste.slice().sort((x, y) => x - y), n = a.length; return !n ? 0 : a[Math.floor((n - 1) / 2)]; };
  const nomMix = st => (st ? `Mix ${st.nom.toLowerCase()}` : "Mix de plantes");
  const planteMix = (t, style) => ({ variantId: null, sku: "", nom: nomMix(styleDe(style)), t, prix: mediane(PLANTES.filter(p => p.t === t).map(p => p.prix)), img: "", stock: Infinity, mix: true });
  const potMix = t => ({ variantId: null, sku: "", nom: "Mix de pots", t, prix: mediane(potsTousDe(t).map(p => p.prix)), img: "", stock: Infinity, mix: true });
  const desTaille = t => {
    const ps = PLANTES_VUES.filter(p => p.t === t), m = potMoinsCher(t);
    return ps.length ? Math.min(...ps.map(p => unite(p, m))) : null;
  };

  // photos de reference : la plante et le pot se lisent dans le nom du fichier
  // « Philosophe_OleaEuropaea_By_Charlot_S-PHI-CPIN10.jpg » : plante S-PHI, pot S-CPIN10
  const REF = {};
  Object.entries(DON.ref || {}).forEach(([t, r]) => {
    if (!r || !r.photo) return;
    // 02/11/2026 : Shopify ajoute « _<identifiant> » aux noms de fichiers en double (« …_S-FAN-CPIN30_77e8476d-….jpg ») : on l'accepte
    const m = decodeURIComponent(r.photo).match(/_((?:XXS|XS|S|M|L|XL))-([A-Z0-9]+)-([A-Z0-9]+)(?:_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?\.(?:jpe?g|png|webp)/i);
    REF[t] = { photo: r.photo, skuPlante: r.skuPlante || (m ? `${m[1]}-${m[2]}` : ""), skuPot: m ? `${m[1]}-${m[3]}` : "" };
  });

  // ------------------------------------------------ l'etat, garde 7 jours dans le navigateur
  const CLE = "studio-pro-v2";
  const SEPT_JOURS = 7 * 24 * 3600 * 1000;
  const ETAT0 = () => ({
    v: 2, taille: null, voie: "mix", lignes: [], n: 0, dernierPot: {}, qteDefaut: 10, persoDefaut: true, gardes: {},
    mixe: { style: null, qte: 10, potVoie: "mix", pot: null, pots: {} },
    etiq: { type: "logo-titre", titre: "", sous: "", parDest: false, mot: "", logoNom: "" },
    livr: { mode: "une", nom: "", adresse: "", cp: "", ville: "", envois: "", date: "", dateDebut: "", dateMode: "precise" },
    contact: { societe: "", nom: "", email: "", telephone: "" },
    ent: { ident: "", sansSiret: false, bc: "", adresse: "", cp: "", ville: "", pays: "France", factIdentique: true },
    ouvert: false,
    occasion: "", message: "", paiement: "carte", etape: "selection", majLe: 0
  });
  let S = ETAT0(), reprise = false, lignesPerdues = 0;
  try {
    const x = JSON.parse(localStorage.getItem(CLE) || "null");
    if (x && x.v === 2 && Date.now() - (x.majLe || 0) < SEPT_JOURS) {
      const base = ETAT0();
      Object.keys(base).forEach(k => {
        if (x[k] === undefined) return;
        base[k] = base[k] && typeof base[k] === "object" && !Array.isArray(base[k]) ? Object.assign(base[k], x[k]) : x[k];
      });
      S = base;
      const avant = S.lignes.length;
      S.lignes = (Array.isArray(S.lignes) ? S.lignes : []).filter(l => l && (l.mix ? TAILLES.some(x => x.t === l.taille) : plante(l.plante)) && C.entier(l.qte) > 0 && (l.mode !== "pot" || pot(l.pot)));
      if (x.livr && x.livr.sansDate) S.livr.dateMode = "auPlusVite";
      S.livr.dateMode = { avant: "precise", entre: "periode", sans: "auPlusVite" }[S.livr.dateMode] || S.livr.dateMode;
      if (!["precise", "periode", "auPlusVite"].includes(S.livr.dateMode)) S.livr.dateMode = "precise";
      // 30/09 : « Texte seul » devient « Titre seul » ou « Titre et sous-titre » ; libelles d'occasion revus
      if (S.etiq.type === "texte") S.etiq.type = "titre-sous";
      if (!["logo-titre", "logo-texte", "logo", "titre", "titre-sous"].includes(S.etiq.type)) S.etiq.type = "logo-titre";
      S.occasion = { "Fin d'année": "Fin d'année, vœux", "Décorer vos bureaux": "Décorer des bureaux" }[S.occasion] || S.occasion;
      if (!S.gardes || typeof S.gardes !== "object" || Array.isArray(S.gardes)) S.gardes = {};
      delete S.reste;
      lignesPerdues = avant - S.lignes.length;
      reprise = S.lignes.length > 0 || !!(S.contact.societe || S.contact.email);
    }
  } catch (e) { S = ETAT0(); }
  if (!S.taille || !TAILLES.some(x => x.t === S.taille)) S.taille = (TAILLES.find(x => x.t === "S") || TAILLES[0] || { t: "S" }).t;
  if (S.etape === "fin") S.etape = "selection";
  let minuteurGarde = null;
  const garder = () => {
    clearTimeout(minuteurGarde);
    minuteurGarde = setTimeout(() => { try { S.majLe = Date.now(); localStorage.setItem(CLE, JSON.stringify(S)); } catch (e) {} }, 250);
  };
  let retourRecap = false;

  // ------------------------------------------------ les lignes et le calcul
  // une ligne : { id, plante (variante), mode : "pot" | "sans" | "choix", pot (variante ou null), qte, etiquette }
  // une ligne mix : { id, mix: true, taille, style, mode : "mixpots" | "pot", pot, qte, etiquette } (plantes choisies par l'equipe)
  const planteDe = l => (l.mix ? planteMix(l.taille, l.style) : plante(l.plante));
  const potDeLigne = l => (l.mode === "pot" ? pot(l.pot) : l.mode === "choix" ? potMoinsCher(planteDe(l).t) : l.mode === "mixpots" ? potMix(l.taille) : null);
  const pieces = () => S.lignes.reduce((s, l) => s + l.qte, 0);
  function besoins(sauf) {
    const pl = new Map(), po = new Map();
    S.lignes.forEach(l => {
      if (l.id === sauf) return;
      if (!l.mix) pl.set(l.plante, (pl.get(l.plante) || 0) + l.qte);
      if (l.mode === "pot") po.set(l.pot, (po.get(l.pot) || 0) + l.qte);
    });
    return { pl, po };
  }
  const adr = { res: null, fichier: null, octets: null, lu: null };
  const nbEnvois = () => (adr.res ? adr.res.envois : (C.entier(S.livr.envois) || pieces() || 1));
  const versCalcul = lignes => lignes.map(l => { const p = planteDe(l), po = potDeLigne(l); return { planteTTC: p.prix / 100, potTTC: po ? po.prix / 100 : 0, qte: l.qte, etiquette: !!l.etiquette }; });
  // prix du site (email personnel sans SIRET ni TVA, decision du 30/09) : aucune remise, livraison calculee sur le montant
  // plein. Meme regle que le script (Studio.gs : tarifPublic, livraisonUneAdresse_) : le total affiche est celui du devis.
  function sansRemise(c) {
    if (!c.pieces) return c;
    const net = c.brut + c.etiquettes, brutPlantes = c.lignes.reduce((s, d) => s + d.plante * d.qte, 0);
    let frais = c.livraison.montant;
    if (c.livraison.mode === "une") {
      frais = Math.min(Math.floor(Math.floor((net * RG.partLivraison) / 100) / RG.arrondiLivraison) * RG.arrondiLivraison, RG.plafondLivraison);
      frais = Math.max(frais, RG.plancherLivraison);
    }
    // les bases de TVA du calcul partage (la livraison B2B a son taux, REGLES.tvaLivraison : 20 % depuis le 01/10/2026)
    const v = C.ventiler(brutPlantes, c.brut - brutPlantes + c.etiquettes, frais), totalHT = net + frais;
    return Object.assign({}, c, {
      taux: 0, remise: 0, net, plafonne: false, tauxBrouillon: 0, pro: false, tarifPublic: true,
      livraison: Object.assign({}, c.livraison, { montant: frais, plafonnee: c.livraison.mode === "une" && frais === RG.plafondLivraison }),
      totalHT, tva: v.tva, totalTTC: totalHT + v.tva, tvaDetail: { base10: v.base10, base20: v.base20 }, parCadeau: Math.round(totalHT / c.pieces)
    });
  }
  function calculer(lignes, livraison) {
    const c = C.calculer(versCalcul(lignes), livraison, { pro: estPro(), etiquetteOfferte: offreEtiquette() });
    return tarifPublic() ? sansRemise(c) : c;
  }
  function calculAvec(livraison) { return calculer(S.lignes, livraison); }
  function calcul() {
    const livraison = S.lignes.length && S.livr.mode === "plusieurs" ? { mode: "plusieurs", envois: nbEnvois() } : { mode: "une" };
    return calculer(S.lignes, livraison);
  }
  // les manques de la selection : une entree par reference (plante ou pot), toutes lignes confondues ; gardee quand le
  // client a laisse notre equipe confirmer cette quantite (S.gardes), rouverte si elle augmente
  function manques() {
    const b = besoins(), res = [];
    b.pl.forEach((q, id) => { const p = plante(id); if (p && q > p.stock) res.push({ type: "plante", item: p, demande: q, dispo: p.stock, stock: p.stock }); });
    b.po.forEach((q, id) => { const p = pot(id); if (p && q > p.stock) res.push({ type: "pot", item: p, demande: q, dispo: p.stock, stock: p.stock }); });
    res.forEach(m => { m.garde = (S.gardes[m.item.variantId] || 0) >= m.demande; });
    return res;
  }
  const listeFr = a => (a.length > 1 ? a.slice(0, -1).join(", ") + " et " + a[a.length - 1] : a.join(""));

  // ------------------------------------------------ les dates (heure de Paris)
  function aujourdhui() {
    try {
      const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
      const v = k => parts.find(x => x.type === k).value;
      return `${v("year")}-${v("month")}-${v("day")}`;
    } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  const versDate = s => { const [a, m, j] = s.split("-").map(Number); return new Date(Date.UTC(a, m - 1, j)); };
  const plusJours = (s, n) => { const d = versDate(s); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
  const dateLongue = s => versDate(s).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" });
  const TRANSPORT_JOURS = RG.transportJours || 2;          // jours ouvres de transport apres l'expedition
  function plusJoursOuvres(s0, n) { let s1 = s0; while (n > 0) { s1 = plusJours(s1, 1); const j = versDate(s1).getUTCDay(); if (j !== 0 && j !== 6) n--; } return s1; }
  // une seule regle de date (decision du 30/09), la meme que le script (Studio.gs : auPlusVite_, reglerAvant_) : une semaine
  // de preparation puis 2 jours ouvres de transport ; une demande du vendredi, du samedi ou du dimanche arrive le mardi
  const auPlusViteDepuis = s => plusJoursOuvres(plusJours(s, JOURS_MINI), TRANSPORT_JOURS);
  const livraisonAuPlusVite = () => auPlusViteDepuis(aujourdhui());
  function reglerAvant(date) {           // dernier jour de reglement pour etre livre a cette date
    let r = plusJours(date, -(JOURS_MINI + TRANSPORT_JOURS));
    while (auPlusViteDepuis(r) > date) r = plusJours(r, -1);
    return r;
  }
  const dateValide = d => !!d && /^\d{4}-\d{2}-\d{2}$/.test(d);
  // le mode reellement envoye : une date precise ou une periode sans date devient « au plus vite »
  const modeDate = () => (S.livr.dateMode !== "auPlusVite" && dateValide(S.livr.date) ? S.livr.dateMode : "auPlusVite");
  function etatDate() {
    const d = S.livr.date;
    if (modeDate() === "auPlusVite") return { vide: true, auPlusVite: true };
    const auj = aujourdhui(), auPlusTot = livraisonAuPlusVite();
    if (d < auj) return { passee: true, auPlusTot };
    if (d < auPlusTot) return { proche: true, auPlusTot };
    return { ok: true, limite: reglerAvant(d) };
  }

  // ------------------------------------------------ SIRET ou TVA intracommunautaire
  const luhn = s => [...s].reverse().reduce((t, c, i) => { let n = +c; if (i % 2) { n *= 2; if (n > 9) n -= 9; } return t + n; }, 0) % 10 === 0;
  // memes formats que le script qui recoit la demande (apps_script/v2/Studio.gs) : la page et le serveur disent la meme chose
  const FORMATS_TVA = {
    AT: /^U\d{8}$/, BE: /^[01]\d{9}$/, BG: /^\d{9,10}$/, CY: /^\d{8}[A-Z]$/, CZ: /^\d{8,10}$/, DE: /^\d{9}$/, DK: /^\d{8}$/,
    EE: /^\d{9}$/, EL: /^\d{9}$/, ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/, FI: /^\d{8}$/, FR: /^[A-HJ-NP-Z0-9]{2}\d{9}$/, HR: /^\d{11}$/,
    HU: /^\d{8}$/, IE: /^(\d{7}[A-W][A-I]?|\d[A-Z+*]\d{5}[A-W])$/, IT: /^\d{11}$/, LT: /^(\d{9}|\d{12})$/, LU: /^\d{8}$/, LV: /^\d{11}$/,
    MT: /^\d{8}$/, NL: /^\d{9}B\d{2}$/, PL: /^\d{10}$/, PT: /^\d{9}$/, RO: /^\d{2,10}$/, SE: /^\d{12}$/, SI: /^\d{8}$/, SK: /^\d{10}$/,
    XI: /^(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/
  };
  function identifier(brut) {
    const s = String(brut || "").toUpperCase().replace(/[\s.\-]/g, "");
    if (!s) return { type: null, valide: false, valeur: "" };
    if (/^\d{14}$/.test(s)) {
      const poste = s.startsWith("356000000") && [...s].reduce((t, c) => t + +c, 0) % 5 === 0;   // La Poste
      return { type: "siret", valeur: s, valide: luhn(s) || poste };
    }
    // un SIREN seul ne suffit pas au script : l'annuaire nous donne le SIRET du siege
    if (/^\d{9}$/.test(s)) return { type: "siren", valeur: s, valide: false, sirenValide: luhn(s) || s === "356000000" };
    const pays = s.slice(0, 2), reste = s.slice(2);
    if (FORMATS_TVA[pays]) {
      let valide = FORMATS_TVA[pays].test(reste);
      if (valide && pays === "FR" && /^\d{2}$/.test(reste.slice(0, 2))) {
        const siren = reste.slice(2);
        valide = (luhn(siren) || siren === "356000000") && Number(reste.slice(0, 2)) === (12 + 3 * (Number(siren) % 97)) % 97;
      }
      return { type: "tva", valeur: s, valide };
    }
    return { type: "inconnu", valeur: s, valide: false };
  }
  const ident = () => identifier(S.ent.ident);
  const tarifPro = () => pieces() >= MIN_PRO;
  // tarif professionnel (decision du 30/09 : le SIRET ne bloque jamais) : SIRET ou TVA valable, OU email d'entreprise ;
  // un email personnel sans l'un ni l'autre paie le prix du site. Avant l'email : la grille des 10 pieces et plus
  // s'affiche (elle ne depend pas du SIRET), les -5 % sous 10 attendent un SIRET ou un email d'entreprise.
  // Meme liste que SP.emailsPerso (apps_script/v2/Studio.gs) ; a l'envoi, la page et le script disent la meme chose.
  const EMAILS_PERSO = /@(gmail|googlemail|hotmail|outlook|live|msn|yahoo|ymail|icloud|me|mac|aol|gmx|orange|wanadoo|free|sfr|neuf|laposte|bbox|numericable|club-internet|protonmail|proton|tutanota|libertysurf|aliceadsl|noos|voila|cegetel)\.[a-z.]+$/i;
  const identValide = () => ident().valide && !S.ent.sansSiret;
  const emailPerso = () => EMAILS_PERSO.test(String(S.contact.email || "").trim());
  const emailSaisi = () => !!String(S.contact.email || "").trim();
  const estPro = () => identValide() || (emailSaisi() && !emailPerso());      // aussi les -5 % sous 10 pieces
  const tarifPublic = () => emailPerso() && !identValide();                   // prix du site, meme 10 pieces et plus

  // ------------------------------------------------ hors zone : France metropolitaine seulement (depuis le 30/09, ni la
  // Corse ni l'outre-mer) ; jamais bloquant, la demande passe « a confirmer ». En differents points, le fichier le dit.
  function horsZone() {
    if (!S.lignes.length) return false;
    if (S.livr.mode === "plusieurs") return !!(adr.res && adr.res.horsZone);
    if (!String(S.livr.cp || "").trim()) return false;
    const r = A ? A.controlerCP(S.livr.cp, "France") : { erreur: !/^\d{5}$/.test(S.livr.cp) };
    return !!r.erreur;
  }

  // ------------------------------------------------ ce que l'equipe confirmera
  function aConfirmer() {
    const a = [], d = etatDate(), q = pieces();
    if (d.passee || d.proche) a.push("date");
    if (manques().length) a.push("stock");
    if (q >= BASCULE) a.push("quantite");
    if (horsZone()) a.push("autre");
    return a;
  }
  const LIB_AC = {
    mix: () => "la composition du mix",
    date: () => "la date de livraison",
    stock: () => "le stock : " + listeFr(manques().map(m => { const n = m.demande - m.dispo; return m.type === "pot" ? `${n} ${pl(n, "pot")} ${m.item.nom}` : `${n} ${nomCourt(m.item.nom)}`; })),
    quantite: () => `le prix (dès ${BASCULE} pièces)`,
    sansSiret: () => "le tarif (sans SIRET)",
    autre: () => (S.livr.mode === "plusieurs" ? "la livraison de certaines adresses" : "la livraison à cette adresse")
  };

  // ------------------------------------------------ annonces pour les lecteurs d'ecran
  let minuteurAnnonce = null, phraseTotal = "";
  const annoncer = texte => { clearTimeout(minuteurAnnonce); minuteurAnnonce = setTimeout(() => { const z = $("#sp2-annonce"); if (z) z.textContent = texte; }, 600); };

  // ================================================= 0. VOS PRIX, TOUT DE SUITE
  function rendrePrix() {
    const txt = (id, t) => { const z = $(id); if (z) z.textContent = t; };
    const dernier = RG.paliers[RG.paliers.length - 1] || PREMIER;
    txt("#sp2-tarif-ligne", `Tarif professionnel : −${pct(PREMIER.taux)} dès ${PREMIER.des} pièces, jusqu'à −${pct(dernier.taux)}.`);
    const z = $("#sp2-paliers");
    if (z) z.innerHTML = RG.paliers.map(p => `<div><b>−${p.taux}&nbsp;%</b><span>dès ${p.des} pièces</span></div>`).join("");
    txt("#sp2-prix-etiq", offreEtiquette() ? `Offerte jusqu'au ${OFFRE.jusquau}` : `${eurHT(RG.etiquetteHT)} la pièce`);
    txt("#sp2-prix-une", `${RG.partLivraison} % de la commande, ` + (RG.plancherLivraison ? `de ${eurRond(RG.plancherLivraison).replace(" HT", "").replace(/\s€$/, "")} à ${eurRond(RG.plafondLivraison)}` : `jusqu'à ${eurRond(RG.plafondLivraison)}`));
    txt("#sp2-prix-plusieurs", `${eurHT(RG.parEnvoi)} l'envoi`);
    const pro = $("#sp2-prix-pro");
    if (pro) { pro.hidden = !RG.remisePetitPro; pro.textContent = `Entreprises : −${pct(RG.remisePetitPro || 0)} dès la première pièce.`; }
    txt("#sp2-hero-reassurance", MIN_ENVOI < MIN_PRO ? `Dès ${MIN_ENVOI} ${pl(MIN_ENVOI, "pièce")} · prix HT` : `Dès ${MIN_PRO} pièces · prix HT`);
    // haut de page (14/10/2026) : le prix d'appel de la petite taille, étiquette personnalisée comprise (comme « Petites
    // dès » du configurateur), et les paliers ; la section écrit déjà ces textes, le calcul les tient à jour
    const hp = $("#sp2-hero-prix"), hpal = $("#sp2-hero-paliers");
    if (hp) {
      const dxs = desTaille("XS");
      hp.hidden = !(dxs > 0);
      if (dxs > 0) hp.innerHTML = `Dès <b>${eurHT(dxs + (offreEtiquette() ? 0 : (RG.etiquetteHT || 0)))}</b> la petite plante personnalisée`;
      hp.classList.remove("a-calculer");
    }
    if (hpal) { hpal.hidden = !PREMIER.taux; hpal.textContent = `Remise de ${pct(PREMIER.taux)} dès ${PREMIER.des} pièces, ${pct(dernier.taux)} dès ${dernier.des}`; hpal.classList.remove("a-calculer"); }
    const des = $("#sp2-des");
    if (des) des.innerHTML = TAILLES.map(x => { const d = desTaille(x.t); return d ? `<span>${x.nom} dès <b>${eurHT(d)}</b></span>` : ""; }).join("");
    txt("#sp2-prix-mention", `Dès ${BASCULE} pièces : prix confirmé sous 24 h.`);
    txt("#sp2-pictos-sur", MIN_ENVOI < MIN_PRO ? `Dès ${MIN_ENVOI} ${pl(MIN_ENVOI, "pièce")}` : `Dès ${MIN_PRO} pièces`);
    txt("#sp2-faq-pieces", `Dès ${MIN_ENVOI} ${pl(MIN_ENVOI, "pièce")}. Tarif professionnel : ` + RG.paliers.map(x => `−${pct(x.taux)} dès ${x.des}`).join(", ").replace(/, ([^,]*)$/, " et $1") + ".");
    txt("#sp2-faq-envoi", `Oui, en France métropolitaine : ${eurHT(RG.parEnvoi)} l'envoi.`);
    txt("#sp2-faq-regler", (VIREMENT_DES > 1 ? `Carte, ou virement dès ${VIREMENT_DES} pièces.` : "Carte ou virement.") + " En différents points de livraison : virement.");
    txt("#sp2-faq-bascule-q", `Et à partir de ${BASCULE} pièces ?`);
    txt("#sp2-perso-prix", offreEtiquette() ? `Offerte jusqu'au ${OFFRE.jusquau}` : `${eurHT(RG.etiquetteHT)} la pièce`);
    // le repère du haut de page : écrit par la section pendant l'offre, caché ici dès qu'elle est finie (cache de page)
    { const ho = $("#sp2-hero-offre"); if (ho) ho.hidden = !offreEtiquette(); }
  }

  // ================================================= 1. SELECTION
  let conseilOuvert = false;
  function rendreTailles() {
    const z = $("#sp2-tailles");
    if (!z.children.length) z.innerHTML = TAILLES.map(x => `<button type="button" data-t="${x.t}"><span class="vue" aria-hidden="true"></span><span class="leg"><b>${x.nom}</b><small><span>${x.h}</span><span>${x.pot}</span></small></span></button>`).join("");
    $$("#sp2-tailles [data-t]").forEach(b => b.setAttribute("aria-pressed", String(S.taille === b.dataset.t)));
    $("#sp2-conseil-lien").setAttribute("aria-expanded", String(conseilOuvert));
    const c = $("#sp2-conseil");
    c.hidden = !conseilOuvert;
    if (conseilOuvert && !c.children.length) c.innerHTML = `<ul>${TAILLES.map(x => `<li><b>${x.nom}</b> : ${x.usage}, dès ${eurHT(desTaille(x.t) || 0)}</li>`).join("")}</ul>`
      + `<p>Le plus offert : les standards. <button type="button" class="lien" data-voir="S">Voir les standards</button></p>`;
  }
  $("#sp2-conseil-lien").addEventListener("click", () => { conseilOuvert = !conseilOuvert; rendreTailles(); });
  $("#sp2-tailles").addEventListener("click", e => {
    const b = e.target.closest("button[data-t]"); if (!b) return;
    S.taille = b.dataset.t; conseilOuvert = false; changerTailleMix(); garder(); rendreTailles(); rendrePlantes(); rendreMix();
  });
  $("#sp2-conseil").addEventListener("click", e => {
    const b = e.target.closest("[data-voir]"); if (!b) return;
    S.taille = b.dataset.voir; conseilOuvert = false; changerTailleMix(); garder(); rendreTailles(); rendrePlantes(); rendreMix();
  });

  function rendrePlantes() {
    const t = S.taille, N = Math.max(1, S.qteDefaut || 10), b = besoins(), m = potMoinsCher(t);
    const reste = p => p.stock - (b.pl.get(p.variantId) || 0);
    const liste = PLANTES_VUES.filter(p => p.t === t);
    $("#sp2-grille-titre").textContent = `${liste.length} ${pl(liste.length, "plante")} · prix HT, pot compris`;
    if (S.lignes.length) $("#sp2-reste").hidden = true;          // « Ajoutez au moins une plante. » (envoi sans selection)
    const zg = $("#sp2-plantes"), poser = h => { if (zg.dataset.h !== h) { zg.dataset.h = h; zg.innerHTML = h; } };   // la grille n'est redessinee que si elle change
    poser(liste.map(p => {
      const q = S.lignes.filter(l => !l.mix && l.plante === p.variantId).reduce((s, l) => s + l.qte, 0), r = reste(p);
      return `<button type="button" class="plante" data-id="${p.variantId}">${q ? `<span class="compte" aria-label="${q} dans votre sélection">${q}</span>` : ""}<img src="${ech(p.img)}" alt="" loading="lazy" width="480" height="600">`
        + `<span class="infos"><b>${ech(p.nom)}</b><span class="p">dès ${eurHT(unite(p, m))}</span>${r < N ? `<span class="s">${Math.max(0, r)} ${pl(Math.max(0, r), "disponible")}</span>` : ""}</span></button>`;
    }).join(""));
  }
  $("#sp2-plantes").addEventListener("click", e => { const b = e.target.closest(".plante"); if (b) ouvrirTiroir(+b.dataset.id); });

  // ------------------------------------------------ deux voies : je choisis mes plantes, ou un mix compose par nos soins
  function rendreVoie() {
    $$("input[name='sp2-voie']").forEach(x => { x.checked = x.value === S.voie; });
    $("#sp2-voie-choix").hidden = S.voie === "mix";
    $("#sp2-voie-mix").hidden = S.voie !== "mix";
    if (S.voie === "mix") rendreMix();
  }
  $$("input[name='sp2-voie']").forEach(x => x.addEventListener("change", () => { S.voie = x.value; garder(); rendreVoie(); toutRendreTotal(); }));
  const mixQte = () => Math.max(1, Math.min(RG.quantiteMax || 5000, C.entier(S.mixe.qte) || 1));
  function changerTailleMix() {          // les pots et les styles dependent de la taille
    S.mixe.pot = null; S.mixe.pots = {};
    if (S.mixe.style && !stylesDe(S.taille).some(x => x.id === S.mixe.style)) S.mixe.style = null;
  }
  function repartir() {                  // plusieurs modeles : la quantite se repartit a parts egales, le reste sur les premiers
    const ids = Object.keys(S.mixe.pots), q = mixQte();
    ids.forEach((id, i) => { S.mixe.pots[id] = Math.floor(q / ids.length) + (i < q % ids.length ? 1 : 0); });
  }
  function majNoteTarif() { const z = $("#sp2-note-tarif"); if (z) z.hidden = !(tarifPublic() && pieces() > 0); }
  function rendreMix() {
    const t = S.taille, styles = stylesDe(t), mp = planteMix(t, S.mixe.style), b = besoins();
    $("#sp2-mix-style-bloc").hidden = !styles.length;
    const zs = $("#sp2-mix-styles"), cle = styles.map(x => x.id).join(",");
    if (zs.dataset.cle !== cle) { zs.dataset.cle = cle; zs.innerHTML = styles.map(x => `<button type="button" data-style="${x.id}">${x.nom}</button>`).join(""); }
    $$("#sp2-mix-styles [data-style]").forEach(x => x.setAttribute("aria-pressed", String(x.dataset.style === S.mixe.style)));
    const champ = $("#sp2-mix-qte");
    if (document.activeElement !== champ) champ.value = mixQte();
    $$("#sp2-mix-raccourcis button").forEach(x => x.setAttribute("aria-pressed", String(+x.dataset.q === mixQte())));
    $$("input[name='sp2-mix-pot']").forEach(x => { x.checked = x.value === S.mixe.potVoie; });
    const grille = $("#sp2-mix-pots"), avecGrille = S.mixe.potVoie !== "mix";
    grille.hidden = !avecGrille;
    if (avecGrille) {
      const cleG = t + ":" + S.mixe.potVoie;
      if (grille.dataset.cle !== cleG) {
        grille.dataset.cle = cleG;
        grille.innerHTML = potsDe(t).map(tuilePot).join("");
        $$("#sp2-mix-pots .pot").forEach(el => el.setAttribute("aria-label", etiquettePot(pot(+el.dataset.pot))));
      }
      $$("#sp2-mix-pots .pot").forEach(el => {
        const id = +el.dataset.pot, x = pot(id), choisi = S.mixe.potVoie === "un" ? S.mixe.pot === id : S.mixe.pots[id] != null;
        const besoin = S.mixe.potVoie === "un" ? mixQte() : (S.mixe.pots[id] || 0), r = x.stock - (b.po.get(id) || 0), sp = el.querySelector(".s");
        el.setAttribute("aria-pressed", String(choisi));
        sp.hidden = !choisi || r >= besoin; sp.textContent = `${Math.max(0, r)} ${pl(Math.max(0, r), "disponible")}`;
      });
    }
    const zr = $("#sp2-mix-repartition"), ids = Object.keys(S.mixe.pots);
    zr.hidden = S.mixe.potVoie !== "plusieurs" || !ids.length;
    if (!zr.hidden) {
      const somme = ids.reduce((s, id) => s + (S.mixe.pots[id] || 0), 0);
      const cleR = ids.join(",");
      if (zr.dataset.cle !== cleR) {
        zr.dataset.cle = cleR;
        zr.innerHTML = ids.map(id => { const x = pot(+id); return `<div class="rep" data-rep="${id}"><img src="${ech(x.img)}" alt=""><span>${ech(x.nom)}</span><div class="compteur"><button type="button" data-rm aria-label="Un de moins pour ${ech(x.nom)}">−</button><input data-rq inputmode="numeric" aria-label="Quantité pour ${ech(x.nom)}"><button type="button" data-rp aria-label="Un de plus pour ${ech(x.nom)}">+</button></div></div>`; }).join("")
          + `<p class="total-rep"></p>`;
      }
      $$("#sp2-mix-repartition [data-rep]").forEach(el => { const inp = el.querySelector("[data-rq]"); if (document.activeElement !== inp) inp.value = S.mixe.pots[el.dataset.rep] || 0; });
      zr.querySelector(".total-rep").textContent = `Réparti : ${somme} sur ${mixQte()}`;
    }
    // prix repere : plante au median de la taille, pot au median (mix de pots) ou au modele choisi
    const lignes = lignesMix(), n = lignes.reduce((s, l) => s + l.qte, 0);
    const total = lignes.reduce((s, l) => s + unite(mp, potDeLigne(l)) * l.qte, 0);
    $("#sp2-mix-prix").textContent = n ? `Environ ${eurHT(Math.round(total / n))} la pièce · composé par notre équipe` : "Composé par notre équipe";
    if (!S.lignes.some(l => l.mix)) rendreTotal(calcul());
  }
  function lignesMix() {
    const base = { mix: true, taille: S.taille, style: S.mixe.style || null };
    if (S.mixe.potVoie === "mix") return [Object.assign({ mode: "mixpots", pot: null, qte: mixQte() }, base)];
    if (S.mixe.potVoie === "un") return S.mixe.pot && pot(S.mixe.pot) ? [Object.assign({ mode: "pot", pot: S.mixe.pot, qte: mixQte() }, base)] : [];
    return Object.keys(S.mixe.pots).filter(id => pot(+id) && S.mixe.pots[id] > 0).map(id => Object.assign({ mode: "pot", pot: +id, qte: S.mixe.pots[id] }, base));
  }
  $("#sp2-mix-styles").addEventListener("click", e => { const b = e.target.closest("[data-style]"); if (!b) return; S.mixe.style = S.mixe.style === b.dataset.style ? null : b.dataset.style; garder(); rendreMix(); });
  const poserMixQte = v => { S.mixe.qte = Math.max(1, Math.min(RG.quantiteMax || 5000, parseInt(String(v).replace(/\D/g, ""), 10) || 1)); if (S.mixe.potVoie === "plusieurs") repartir(); garder(); rendreMix(); };
  $("#sp2-voie-mix").addEventListener("click", e => {
    if (e.target.closest("[data-mix-moins]")) return poserMixQte(mixQte() - 1);
    if (e.target.closest("[data-mix-plus]")) return poserMixQte(mixQte() + 1);
    const rq = e.target.closest("#sp2-mix-raccourcis [data-q]"); if (rq) { poserMixQte(rq.dataset.q); $("#sp2-mix-qte").value = mixQte(); return; }
    const po = e.target.closest("#sp2-mix-pots .pot");
    if (po) {
      const id = +po.dataset.pot;
      if (S.mixe.potVoie === "un") S.mixe.pot = id;
      else { if (S.mixe.pots[id] != null) delete S.mixe.pots[id]; else S.mixe.pots[id] = 0; repartir(); }
      $("#sp2-mix-note").hidden = true; garder(); rendreMix(); return;
    }
    const rep = e.target.closest("[data-rep]");
    if (rep && (e.target.closest("[data-rm]") || e.target.closest("[data-rp]"))) {
      const id = rep.dataset.rep; S.mixe.pots[id] = Math.max(0, (S.mixe.pots[id] || 0) + (e.target.closest("[data-rp]") ? 1 : -1)); garder(); rendreMix();
    }
  });
  $("#sp2-mix-qte").addEventListener("input", e => { if (/\d/.test(e.target.value)) poserMixQte(e.target.value); });
  $("#sp2-mix-qte").addEventListener("change", e => { poserMixQte(e.target.value); e.target.value = mixQte(); });
  $("#sp2-mix-repartition").addEventListener("change", e => {
    const rep = e.target.closest("[data-rep]"); if (!rep || !e.target.matches("[data-rq]")) return;
    S.mixe.pots[rep.dataset.rep] = Math.max(0, parseInt(e.target.value.replace(/\D/g, ""), 10) || 0); garder(); rendreMix();
  });
  $$("input[name='sp2-mix-pot']").forEach(x => x.addEventListener("change", () => {
    S.mixe.potVoie = x.value; S.mixe.pot = null; S.mixe.pots = {}; $("#sp2-mix-note").hidden = true;
    if (x.value === "un") { const avant = potsDe(S.taille).find(p => EN_AVANT.includes(p.sku)); if (avant) S.mixe.pot = avant.variantId; }   // petite taille : le pot mis en avant d'office
    garder(); rendreMix();
  }));
  $("#sp2-mix-ajouter").addEventListener("click", () => {
    const lignes = lignesMix(), note = $("#sp2-mix-note");
    if (!lignes.length) {
      note.hidden = false; note.textContent = S.mixe.potVoie === "un" ? "Choisissez un modèle de pot." : "Choisissez vos modèles de pot.";
      const g = $("#sp2-mix-pots .pot"); if (g) g.focus();
      return;
    }
    note.hidden = true;
    lignes.forEach(l => ajouterLigne(Object.assign({ etiquette: S.persoDefaut }, l)));
    const n = lignes.reduce((s, l) => s + l.qte, 0);
    toutRendre(); garder();
    annoncer(`Mix de ${n} ${pl(n, "plante")} ajouté. ${phraseTotal}`);
  });

  // ------------------------------------------------ les manques de stock : un seul composant (schema du 30/09/2026,
  // strateges/v2/manques_stock.md). Le meme bloc, pour une plante comme pour un pot, dans le tiroir et dans la feuille
  // « Ajuster ». Rien n'est jamais bloquant : le client complete avec d'autres references de la meme taille, ou garde
  // sa demande (S.gardes) et notre equipe confirme ; un manque garde se rouvre si la quantite augmente.
  // Un contexte m : { type: "plante" | "pot", item, demande, dispo, stock, compl: { variantId: n }, gardeQ, garde, tout }
  const Manque = {
    manque: m => Math.max(0, m.demande - m.dispo),
    somme: m => Object.values(m.compl).reduce((s, n) => s + n, 0),
    nom: (m, x) => (m.type === "pot" ? x.nom : nomCourt(x.nom)),
    // les vignettes : meme taille, celles que la grille montre (jamais masquees), prix le plus proche puis stock
    options(m, b) {
      const it = m.item, usage = m.type === "pot" ? b.po : b.pl;
      return (m.type === "pot" ? potsDe(it.t) : PLANTES_VUES.filter(x => x.t === it.t))
        .filter(x => x.variantId !== it.variantId)
        .map(x => ({ x, reste: Math.max(0, x.stock - (usage.get(x.variantId) || 0)) }))
        .filter(o => o.reste > 0)
        .sort((a, c) => Math.abs(a.x.prix - it.prix) - Math.abs(c.x.prix - it.prix) || c.reste - a.reste);
    },
    // ce que la reference ajoute a la piece (HT), montre seulement si elle est plus chere
    plus: (m, x) => (m.type === "pot" ? htPot(x) - htPot(m.item) : unite(x, null) - unite(m.item, null)),
    cle: (m, opts) => [m.type, m.item.variantId, m.demande, m.dispo, m.garde ? 1 : 0, m.tout ? 1 : 0, opts.map(o => o.x.variantId + ":" + o.reste).join(",")].join("|"),
    html(m, opts) {
      const q = m.demande, d = m.dispo, n = Manque.manque(m), nom = ech(Manque.nom(m, m.item)), pot = m.type === "pot";
      const tete = d > 0
        ? `Nous n'avons que ${d} ${pot ? pl(d, "pot") + " " : ""}${nom} ${pl(d, "disponible")} sur les ${q} demandés.`
        : `${m.stock > 1 ? "Vos" : "Votre"} ${m.stock} ${pot ? pl(m.stock, "pot") + " " : ""}${nom} ${pl(m.stock, "disponible")} ${m.stock > 1 ? "sont" : "est"} déjà dans votre sélection.`;
      let h = `<div class="manque${m.garde ? " garde-etat" : ""}" data-manque="${m.type}"><p class="tete"><i class="point" aria-hidden="true"></i><span>${tete}</span></p>`;
      if (m.garde) {
        return h + `<p class="garde">${pot ? `Vous gardez ce pot pour les ${q}` : `Vous gardez les ${q} ${nom}`} : notre équipe vous confirme les ${n} autres sous 24&nbsp;h. `
          + `<button type="button" class="lien" data-m="completer">Compléter plutôt</button></p></div>`;
      }
      const vues = m.tout ? opts.slice() : opts.slice(0, 3);
      opts.forEach(o => { if (!vues.includes(o) && m.compl[o.x.variantId]) vues.push(o); });      // un choix reste toujours visible
      h += `<p class="sous">${d > 0 ? `Complétez les ${n} autres :` : pot ? "Complétez avec un autre pot :" : "Complétez avec une autre plante :"}</p>`;
      if (vues.length) h += `<div class="vignettes">` + vues.map(o => {
        const x = o.x, nx = ech(Manque.nom(m, x)), plus = Manque.plus(m, x);
        const petit = [o.reste < n ? `${o.reste} dispo.` : "", plus > 0 ? `+ ${eur(plus)}` : ""].filter(Boolean).join(" · ");
        return `<div class="vg" data-vg="${x.variantId}"><button type="button" class="vg-choix" aria-pressed="false" aria-label="${nx}${petit ? ", " + ech(petit) : ""}">`
          + `<span class="ph"><img src="${ech(x.img)}" alt="" loading="lazy" width="200" height="200"><span class="ajout" aria-hidden="true">+</span></span>`
          + `<span class="nom"><b>${nx}</b><small>${ech(petit)}</small></span></button>`
          + `<span class="vg-qte" hidden><span class="reglage"><button type="button" data-m="moins" aria-label="${nx} : une de moins">−</button><b></b><button type="button" data-m="plus" aria-label="${nx} : une de plus">+</button></span></span></div>`;
      }).join("") + `</div>`;
      h += `<div class="bas">${!m.tout && opts.length > vues.length ? `<button type="button" class="lien" data-m="tout">${pot ? "Voir tous les pots" : "Voir toutes les plantes"}</button>` : "<span></span>"}`
        + `<span class="etat" data-m-etat aria-live="polite"></span></div>`;
      return h + `<p class="garder"><button type="button" class="lien" data-m="garder">${pot ? `Garder ce pot pour les ${q}` : `Garder les ${q} ${nom}`}</button></p></div>`;
    },
    // les quantites et l'etat sans redessiner : un clic en cours n'est jamais perdu
    maj(z, m) {
      z.querySelectorAll("[data-vg]").forEach(el => {
        const k = m.compl[+el.dataset.vg] || 0, pas = el.querySelector(".vg-qte");
        el.classList.toggle("oui", k > 0);
        el.querySelector(".vg-choix").setAttribute("aria-pressed", String(k > 0));
        pas.hidden = !k; pas.querySelector("b").textContent = k;
      });
      const e = z.querySelector("[data-m-etat]"), r = Manque.manque(m) - Manque.somme(m);
      if (e) { const t = r > 0 ? `Encore ${r} à compléter` : "Complet"; if (e.textContent !== t) { e.textContent = t; e.className = "etat " + (r > 0 ? "attente" : "ok"); } }
    },
    rendre(z, m, b) {
      if (!m) { if (z.dataset.cle) { z.dataset.cle = ""; z.innerHTML = ""; } return; }
      const opts = Manque.options(m, b), cle = Manque.cle(m, opts);
      if (z.dataset.cle !== cle) { z.dataset.cle = cle; z.innerHTML = Manque.html(m, opts); }
      Manque.maj(z, m);
    },
    // un clic dans le bloc ; renvoie ce qui a ete fait. Toucher une vignette lui donne ce qui manque (dans la limite
    // de son stock) ; − et + sont bornes par son stock et par la quantite demandee.
    clic(m, e, b) {
      const a = e.target.closest("[data-m]"), v = e.target.closest("[data-vg]");
      const act = a ? a.dataset.m : v && e.target.closest(".vg-choix") ? "choix" : "";
      if (act === "garder") { m.gardeQ = m.demande; m.garde = true; m.compl = {}; return act; }
      if (act === "completer") { m.gardeQ = 0; m.garde = false; return act; }
      if (act === "tout") { m.tout = true; return act; }
      if (!v || !act) return "";
      const o = Manque.options(m, b).find(x => x.x.variantId === +v.dataset.vg); if (!o) return "";
      const id = o.x.variantId, k = m.compl[id] || 0, autres = Manque.somme(m) - k;
      const borne = n => Math.max(0, Math.min(n, o.reste, m.demande - autres));
      if (act === "plus") m.compl[id] = borne(k + 1);
      else if (act === "moins") m.compl[id] = Math.max(0, k - 1);
      else m.compl[id] = k ? 0 : borne(Math.max(1, Manque.manque(m) - autres));
      if (!m.compl[id]) delete m.compl[id];
      return act;
    }
  };
  const focaliser = sel => { const x = $(sel); if (x) x.focus({ preventScroll: true }); };

  // ------------------------------------------------ le tiroir : pot et quantite
  const tiroir = $("#sp2-tiroir");
  const T = { plante: null, mode: "pot", pot: null, qte: 10, ligne: null, m: null };
  function ouvrirTiroir(idPlante, ligne) {
    const p = plante(idPlante); if (!p) return;
    T.plante = p.variantId; T.ligne = ligne ? ligne.id : null; T.m = null;
    if (ligne) { T.mode = ligne.mode; T.pot = ligne.pot; T.qte = ligne.qte; }
    else {
      const d = S.dernierPot[p.t];
      if (d === "sans" || d === "choix") { T.mode = d; T.pot = null; }
      else if (d && pot(d)) { T.mode = "pot"; T.pot = d; }
      else {
        // premier pot propose : une ceramique qui suit la quantite, sinon le pot le plus disponible
        const q = Math.max(1, S.qteDefaut || 10), b = besoins(), reste = x => x.stock - (b.po.get(x.variantId) || 0);
        const defaut = potsDe(p.t).find(x => EN_AVANT.includes(x.sku) && reste(x) >= q) || potsDe(p.t).find(x => /c[ée]ramique/i.test(x.nom) && reste(x) >= q) || potsDe(p.t).slice().sort((x, y) => reste(y) - reste(x))[0];
        T.mode = defaut ? "pot" : "sans"; T.pot = defaut ? defaut.variantId : null;
      }
      T.qte = Math.max(1, S.qteDefaut || 10);
    }
    $("#sp2-t-img").src = p.img; $("#sp2-t-img").alt = "";
    $("#sp2-t-nom").textContent = p.nom;
    $("#sp2-t-taille").textContent = `${taille(p.t).nom} · ${taille(p.t).detail}`;
    $("#sp2-t-stock").dataset.cle = "\u0000";
    rendreTiroir(true);
    if (typeof tiroir.showModal === "function") { if (!tiroir.open) tiroir.showModal(); } else tiroir.setAttribute("open", "");
    $(".tiroir-corps", tiroir).scrollTop = 0;     // le focus va au bouton de fermeture (la fenetre native) : pas de clavier qui surgit sur telephone
  }
  function fermerTiroir() { if (typeof tiroir.close === "function" && tiroir.open) tiroir.close(); else tiroir.removeAttribute("open"); }
  $("#sp2-t-fermer").onclick = fermerTiroir;
  tiroir.addEventListener("click", e => { if (e.target === tiroir) fermerTiroir(); });     // un clic sur le voile ferme

  // un seul bloc a la fois : la plante d'abord ; si le pot manque aussi, il se signale dans sa grille
  function contexteTiroir(p, po, b) {
    const dP = Math.max(0, p.stock - (b.pl.get(p.variantId) || 0));
    let m = null;
    if (T.qte > dP) m = { type: "plante", item: p, dispo: dP, stock: p.stock };
    else if (T.mode === "pot" && po) {
      const dPo = Math.max(0, po.stock - (b.po.get(po.variantId) || 0));
      if (T.qte > dPo) m = { type: "pot", item: po, dispo: dPo, stock: po.stock };
    }
    if (!m) { T.m = null; return null; }
    m.demande = T.qte;
    const avant = T.m && T.m.type === m.type && T.m.item.variantId === m.item.variantId ? T.m : null;
    const ailleurs = (m.type === "plante" ? b.pl : b.po).get(m.item.variantId) || 0;           // les autres lignes
    m.compl = avant ? avant.compl : {};
    m.tout = avant ? avant.tout : false;
    m.gardeQ = avant ? avant.gardeQ : Math.max(0, (S.gardes[m.item.variantId] || 0) - ailleurs);
    m.garde = m.gardeQ > 0 && m.gardeQ >= m.demande;
    if (m.garde) m.compl = {};
    let reste = m.demande;                                                                    // la quantite a pu baisser
    Object.keys(m.compl).forEach(id => { m.compl[id] = Math.min(m.compl[id], reste); reste -= m.compl[id]; if (!m.compl[id]) delete m.compl[id]; });
    return (T.m = m);
  }
  // la repartition du tiroir : la reference choisie garde « demande moins complete », une part par reference choisie
  function segmentsTiroir(p) {
    const m = T.m, potChoix = T.mode === "choix" ? potMoinsCher(p.t) : null;
    const seg = (idP, idPo, q) => {
      const x = plante(idP), y = T.mode === "pot" ? pot(idPo) : potChoix;
      return { plante: idP, pot: T.mode === "pot" ? idPo : null, qte: q, u: unite(x, y), nom: m && m.type === "pot" ? (y ? y.nom : "") : nomCourt(x.nom) };
    };
    if (!m || m.garde || !Manque.somme(m)) return [seg(p.variantId, T.pot, T.qte)];
    const s = Math.min(T.qte, Manque.somme(m)), res = [];
    if (T.qte - s > 0) res.push(seg(p.variantId, T.pot, T.qte - s));
    Object.entries(m.compl).forEach(([id, n]) => { if (n > 0) res.push(m.type === "plante" ? seg(+id, T.pot, n) : seg(p.variantId, +id, n)); });
    return res;
  }
  function rendreTiroir(complet) {
    const p = plante(T.plante); if (!p) return;
    const b = besoins(T.ligne), m = potMoinsCher(p.t);
    if (complet) {
      $("#sp2-t-pots").innerHTML =
        `<button type="button" class="pot special" data-mode="sans">Sans pot</button>`
        + (m ? `<button type="button" class="pot special" data-mode="choix">Pots assortis par nos soins</button>` : "")
        + potsDe(p.t).map(tuilePot).join("");
    }
    $$("#sp2-t-pots .pot").forEach(el => {
      const sel = el.dataset.mode ? T.mode === el.dataset.mode : (T.mode === "pot" && T.pot === +el.dataset.pot);
      el.setAttribute("aria-pressed", String(sel));
      if (el.dataset.pot) {
        const x = pot(+el.dataset.pot), r = Math.max(0, x.stock - (b.po.get(x.variantId) || 0)), s = el.querySelector(".s");
        s.hidden = r >= T.qte; s.textContent = `${r} dispo.`;
        el.setAttribute("aria-label", etiquettePot(x) + (r < T.qte ? `, ${r} ${pl(r, "disponible")}` : ""));
      } else el.setAttribute("aria-label", el.dataset.mode === "sans" ? `Sans pot, ${eurHT(unite(p, null))} la pièce` : `Pots assortis par nos soins, ${eurHT(unite(p, m))} la pièce`);
    });
    const po = T.mode === "pot" ? pot(T.pot) : null;
    const dPo = po ? Math.max(0, po.stock - (b.po.get(po.variantId) || 0)) : Infinity;
    $("#sp2-t-pot-nom").innerHTML = ech(T.mode === "sans" ? "Sans pot" : T.mode === "choix" ? "Pots assortis par nos soins" : po ? po.nom : "")
      + (po && dPo < T.qte ? ` <span class="court">· ${dPo} dispo.</span>` : "");
    $("#sp2-t-choix-note").hidden = T.mode !== "choix";
    const champ = $("#sp2-t-qte");
    if (document.activeElement !== champ) champ.value = T.qte;
    $$("#sp2-t-raccourcis button").forEach(x => x.setAttribute("aria-pressed", String(+x.dataset.q === T.qte)));
    const ctx = contexteTiroir(p, po, b), segs = segmentsTiroir(p);
    $("#sp2-t-total").textContent = eurHT(segs.reduce((s, x) => s + x.u * x.qte, 0));
    $("#sp2-t-detail").textContent = segs.length > 1 ? segs.map(x => `${x.qte} ${x.nom}`).join(" + ") : `${T.qte} × ${eurHT(segs[0].u)}`;
    $("#sp2-t-ajouter").textContent = T.ligne ? "Mettre à jour" : `Ajouter ${T.qte} ${pl(T.qte, "pièce")}`;
    Manque.rendre($("#sp2-t-stock"), ctx, b);
  }
  $("#sp2-t-pots").addEventListener("click", e => {
    const b = e.target.closest(".pot"); if (!b) return;
    if (b.dataset.mode) { T.mode = b.dataset.mode; T.pot = null; } else { T.mode = "pot"; T.pot = +b.dataset.pot; }
    rendreTiroir();
  });
  const poserQte = v => { const n = parseInt(String(v).replace(/\D/g, ""), 10); T.qte = Math.max(1, Math.min(RG.quantiteMax || 5000, n || 1)); rendreTiroir(); };
  $("#sp2-t-moins").onclick = () => poserQte(T.qte - 1);
  $("#sp2-t-plus").onclick = () => poserQte(T.qte + 1);
  $("#sp2-t-qte").addEventListener("input", e => { if (/\d/.test(e.target.value)) poserQte(e.target.value); });
  $("#sp2-t-qte").addEventListener("change", e => { poserQte(e.target.value); e.target.value = T.qte; });
  $("#sp2-t-qte").addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); poserQte(e.target.value); $("#sp2-t-ajouter").click(); } });
  $("#sp2-t-raccourcis").addEventListener("click", e => { const b = e.target.closest("[data-q]"); if (b) { poserQte(b.dataset.q); $("#sp2-t-qte").value = T.qte; } });
  $("#sp2-t-stock").addEventListener("click", e => {
    if (!T.m) return;
    const act = Manque.clic(T.m, e, besoins(T.ligne)); if (!act) return;
    rendreTiroir();
    if (act === "garder") focaliser("#sp2-t-stock [data-m='completer']");
    else if (act === "completer") focaliser("#sp2-t-stock .vg-choix");
    else if (act === "tout") focaliser("#sp2-t-stock .vg:nth-child(4) .vg-choix");
  });
  // la ligne du tiroir : mise a jour si on l'edite, ajoutee sinon
  function poserLigne(o) {
    if (T.ligne) { const l = S.lignes.find(x => x.id === T.ligne); if (l) { Object.assign(l, o); regrouper(); return; } }
    ajouterLigne(Object.assign({ etiquette: S.persoDefaut }, o));
  }
  function ajouterLigne(o) {
    const meme = S.lignes.find(l => !!l.mix === !!o.mix && (o.mix ? l.taille === o.taille && (l.style || null) === (o.style || null) : l.plante === o.plante) && l.mode === o.mode && (l.mode !== "pot" || l.pot === o.pot) && !!l.etiquette === !!o.etiquette);
    if (meme) meme.qte += o.qte; else S.lignes.push(Object.assign({ id: ++S.n }, o, { etiquette: !!o.etiquette }));
  }
  function regrouper() {
    const vues = [];
    S.lignes.forEach(l => {
      const m = vues.find(v => !!v.mix === !!l.mix && (l.mix ? v.taille === l.taille && (v.style || null) === (l.style || null) : v.plante === l.plante) && v.mode === l.mode && (l.mode !== "pot" || v.pot === l.pot) && !!v.etiquette === !!l.etiquette);
      if (m) m.qte += l.qte; else vues.push(l);
    });
    S.lignes = vues;
  }
  function apresAjout(message) {
    const p = plante(T.plante), ligne = T.ligne;
    S.dernierPot[p.t] = T.mode === "pot" ? T.pot : T.mode;
    fermerTiroir(); toutRendre(); garder();
    annoncer(`${message} ${phraseTotal}`);
    const cible = ligne ? $(`#sp2-lignes .ligne-sel[data-id="${ligne}"] .nom-ligne`) : $(`#sp2-plantes .plante[data-id="${p.variantId}"]`);
    if (cible) cible.focus({ preventScroll: true });
  }
  $("#sp2-t-ajouter").onclick = () => {
    poserQte($("#sp2-t-qte").value);
    const p = plante(T.plante), segs = segmentsTiroir(p), m = T.m;
    const l0 = T.ligne ? S.lignes.find(x => x.id === T.ligne) : null, etiq = l0 ? !!l0.etiquette : S.persoDefaut;
    segs.forEach((sg, i) => {
      const o = { plante: sg.plante, mode: T.mode, pot: sg.pot, qte: sg.qte };
      if (i === 0) poserLigne(o); else ajouterLigne(Object.assign({ etiquette: etiq }, o));
    });
    if (m) {                                              // garde : la quantite de toute la selection pour cette reference
      const id = m.item.variantId, b = besoins(), total = (m.type === "plante" ? b.pl : b.po).get(id) || 0;
      if (m.garde) S.gardes[id] = total; else if ((S.gardes[id] || 0) < total) delete S.gardes[id];
    }
    if (!T.ligne) S.qteDefaut = T.qte;
    const quoi = segs.length > 1 ? segs.map(x => `${x.qte} ${x.nom}`).join(" et ") : `${T.qte} ${nomCourt(p.nom)}`;
    apresAjout(`${quoi} ${T.ligne ? "mises à jour" : "ajoutées à votre sélection"}.`);
  };

  // ------------------------------------------------ la selection
  function descriptionLigne(l) {
    const p = planteDe(l), po = potDeLigne(l);
    const quoi = l.mode === "sans" ? "sans pot" : l.mode === "choix" || l.mode === "mixpots" ? "pots assortis par nos soins" : (po ? po.nom : "");
    return { p, po, quoi, u: unite(p, po) };
  }
  // une ligne touchee par un manque : « a ajuster » tant qu'il est ouvert, « a confirmer » une fois garde
  function etatLigne(l, ms) {
    const touche = ms.filter(m => (m.type === "plante" ? !l.mix && l.plante === m.item.variantId : l.mode === "pot" && l.pot === m.item.variantId));
    return !touche.length ? "" : touche.some(m => !m.garde) ? "ajuster" : "confirmer";
  }
  function rendreLignes(c) {
    const z = $("#sp2-lignes");
    const q = pieces(), ms = manques();
    $("#sp2-sel-compte").textContent = q ? `${q} ${pl(q, "pièce")} · ${S.lignes.length} ${pl(S.lignes.length, "ligne")}` : "";
    rendreEncart(ms);
    if (!S.lignes.length) { z.dataset.cle = ""; z.innerHTML = `<div class="vide-selection">Aucune plante pour l'instant.</div>`; return; }
    // tant que les lignes sont les memes, on ne remplace aucun bouton : un clic en cours n'est jamais perdu
    const cle = S.lignes.map(l => `${l.id}:${l.mix ? "mix-" + l.taille + "-" + l.style : l.plante}:${l.mode}:${l.pot}`).join("|");
    if (z.dataset.cle !== cle) {
      z.dataset.cle = cle;
      z.innerHTML = S.lignes.map(l => {
        const { p, po, quoi, u } = descriptionLigne(l);
        return `<div class="ligne-sel" data-id="${l.id}">
        ${l.mix ? `<span class="pl mixte" aria-hidden="true">Mix</span>` : `<img class="pl" src="${ech(p.img)}" alt="" loading="lazy" width="52" height="64">`}
        ${po && l.mode === "pot" ? `<img class="po" src="${ech(po.img)}" alt="" loading="lazy" width="36" height="36">` : `<span class="po${l.mode === "sans" ? "" : " assortis"}" aria-hidden="true">${l.mode === "sans" ? "sans" : ""}</span>`}
        <div class="quoi">${l.mix ? `<span class="nom-ligne">${ech(p.nom)}</span>` : `<button type="button" class="nom-ligne" data-editer aria-label="Modifier la ligne ${ech(p.nom)}">${ech(p.nom)}</button>`}<span>${ech(taille(p.t).nom)} · ${ech(quoi)} · ${l.mix ? "environ " : ""}${eurHT(u)} la pièce</span><span class="tag" hidden></span></div>
        <div class="compteur"><button type="button" data-m aria-label="Une ${ech(nomCourt(p.nom))} de moins">−</button><input value="${l.qte}" inputmode="numeric" data-q aria-label="Quantité de ${ech(p.nom)}"><button type="button" data-p aria-label="Une ${ech(nomCourt(p.nom))} de plus">+</button></div>
        <span class="montant"></span>
        <button type="button" class="suppr" data-s aria-label="Retirer ${ech(p.nom)} de la sélection">×</button></div>`;
      }).join("");
    }
    S.lignes.forEach((l, i) => {
      const el = z.querySelector(`.ligne-sel[data-id="${l.id}"]`); if (!el) return;
      const { u } = descriptionLigne(l);
      const inp = el.querySelector("[data-q]"); if (document.activeElement !== inp) inp.value = l.qte;
      el.querySelector(".montant").textContent = eur(c && c.lignes[i] ? c.lignes[i].total : u * l.qte);
      const tg = el.querySelector(".tag"), et = etatLigne(l, ms);
      tg.hidden = !et; tg.className = "tag" + (et === "ajuster" ? " ambre" : et === "confirmer" ? " gris" : "");
      tg.textContent = et === "ajuster" ? "à ajuster" : et === "confirmer" ? "à confirmer" : "";
    });
  }
  const ligneDe = el => { const d = el.closest(".ligne-sel"); return d ? S.lignes.find(x => x.id === +d.dataset.id) : null; };
  $("#sp2-lignes").addEventListener("click", e => {
    const l = ligneDe(e.target); if (!l) return;
    if (e.target.closest("[data-m]")) { l.qte = Math.max(1, l.qte - 1); majLignes(); return; }
    if (e.target.closest("[data-p]")) { l.qte = Math.min(RG.quantiteMax || 5000, l.qte + 1); majLignes(); return; }
    if (e.target.closest("[data-s]")) {
      const nom = planteDe(l).nom; S.lignes = S.lignes.filter(x => x !== l); toutRendre(); garder(); annoncer(`${nom} retirée de votre sélection. ${phraseTotal}`);
      const suivant = $("#sp2-lignes .nom-ligne") || $("#sp2-plantes .plante"); if (suivant) suivant.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest("[data-editer]") && !l.mix) ouvrirTiroir(l.plante, l);
  });
  $("#sp2-lignes").addEventListener("change", e => {
    if (!e.target.matches("[data-q]")) return;
    const l = ligneDe(e.target); if (!l) return;
    l.qte = Math.max(1, Math.min(RG.quantiteMax || 5000, parseInt(e.target.value.replace(/\D/g, ""), 10) || 1));
    majLignes();
  });
  $("#sp2-lignes").addEventListener("keydown", e => { if (e.key === "Enter" && e.target.matches("[data-q]")) { e.preventDefault(); e.target.dispatchEvent(new Event("change", { bubbles: true })); } });
  function majLignes() { toutRendre(); garder(); }

  // ------------------------------------------------ l'encart « Stock a ajuster », seul en tete de la selection
  // une ligne par reference (plante ou pot), 3 au plus puis « et N autres » ; regle : « Tout est disponible. » 4 s
  let encartVu = false, okJusqua = 0;
  function rendreEncart(ms) {
    const z = $("#sp2-encart"), ouverts = ms.filter(m => !m.garde);
    const libelle = m => (m.type === "pot" ? `Pot ${m.item.nom}` : nomCourt(m.item.nom));
    let h = "";
    if (ouverts.length) {
      h = `<div class="encart" role="group" aria-labelledby="sp2-encart-t"><div class="t" id="sp2-encart-t">Stock à ajuster<em aria-label="${ouverts.length} ${pl(ouverts.length, "référence")}">${ouverts.length}</em></div><ul>`
        + ouverts.slice(0, 3).map(m => `<li><span>${ech(libelle(m))}</span><span>${m.dispo} dispo. sur ${m.demande}</span></li>`).join("")
        + (ouverts.length > 3 ? `<li><span>et ${ouverts.length - 3} ${pl(ouverts.length - 3, "autre")}</span><span></span></li>` : "")
        + `</ul><div class="actions"><button type="button" class="bouton petit" data-ajuster>Ajuster</button><button type="button" class="lien" data-garder-tout>Laisser notre équipe confirmer</button></div></div>`;
    } else if (ms.length) h = `<div class="encart calme">Stock : notre équipe vous confirme sous 24&nbsp;h. <button type="button" class="lien" data-ajuster>Ajuster</button></div>`;
    if (ms.length) { encartVu = true; okJusqua = 0; }
    else if (encartVu) { encartVu = false; okJusqua = Date.now() + 4000; setTimeout(() => rendreEncart(manques()), 4100); }
    if (!ms.length && Date.now() < okJusqua) h = `<div class="encart ok" role="status">Tout est disponible.</div>`;
    if (z.dataset.h !== h) { z.dataset.h = h; z.innerHTML = h; }
    z.hidden = !h;
  }
  // « Laisser notre equipe confirmer » et « Continuer » gardent tous les manques ouverts
  function garderManques() { manques().forEach(m => { if (!m.garde) S.gardes[m.item.variantId] = m.demande; }); }
  $("#sp2-encart").addEventListener("click", e => {
    if (e.target.closest("[data-ajuster]")) { ouvrirAjuster(); return; }
    if (e.target.closest("[data-garder-tout]")) { garderManques(); toutRendre(); garder(); annoncer("Stock : notre équipe vous confirme sous 24 h."); focaliser("#sp2-encart [data-ajuster]"); }
  });

  // ------------------------------------------------ « Ajuster » : la feuille du tiroir, un manque a la fois
  const feuille = $("#sp2-aj-feuille");
  const AJ = { liste: [], i: 0, m: null };
  function contexteAjuster() {
    const ref = AJ.liste[AJ.i]; if (!ref) return null;
    const item = ref.type === "pot" ? pot(ref.id) : plante(ref.id); if (!item) return null;
    const b = besoins(), demande = (ref.type === "pot" ? b.po : b.pl).get(ref.id) || 0;
    if (demande <= item.stock) { AJ.m = null; return null; }                                 // regle entre-temps
    const avant = AJ.m && AJ.m.item.variantId === ref.id ? AJ.m : null;
    const m = { type: ref.type, item, demande, dispo: item.stock, stock: item.stock, compl: avant ? avant.compl : {}, tout: avant ? avant.tout : false,
      gardeQ: avant ? avant.gardeQ : (S.gardes[ref.id] || 0) };
    m.garde = m.gardeQ > 0 && m.gardeQ >= demande;
    if (m.garde) m.compl = {};
    return (AJ.m = m);
  }
  function rendreAjuster() {
    const n = AJ.liste.length, ref = AJ.liste[AJ.i], item = ref.type === "pot" ? pot(ref.id) : plante(ref.id), m = contexteAjuster();
    $("#sp2-aj-progres").innerHTML = AJ.liste.map((_, k) => `<i class="${k < AJ.i ? "fait" : k === AJ.i ? "ici" : ""}"></i>`).join("") + `<span>${AJ.i + 1} sur ${n}</span>`;
    $("#sp2-aj-img").src = item.img; $("#sp2-aj-nom").textContent = item.nom;
    $("#sp2-aj-detail").textContent = ref.type === "pot" ? `Pot · ${taille(item.t).court.replace(/^./, x => x.toUpperCase())}` : `${taille(item.t).nom} · ${taille(item.t).detail}`;
    const z = $("#sp2-aj-manque");
    if (m) Manque.rendre(z, m, besoins());
    else { z.dataset.cle = "ok"; z.innerHTML = `<p class="etat ok">Complet</p>`; }
    $("#sp2-aj-prec").hidden = AJ.i === 0;
    $("#sp2-aj-suiv").textContent = AJ.i >= n - 1 ? "Terminer" : "Suivant";
  }
  // appliquer : la ligne courte garde « demande moins complete », une ligne neuve par reference choisie (meme pot et
  // meme etiquette pour une plante, meme plante pour un pot) ; l'excedent se prend sur la derniere ligne ajoutee
  function appliquerAjuster() {
    const m = AJ.m; AJ.m = null; if (!m) return;
    const id = m.item.variantId;
    if (m.garde) { S.gardes[id] = m.demande; return; }
    if ((S.gardes[id] || 0) >= m.demande) delete S.gardes[id];                               // « Completer plutot »
    let aPrendre = Math.min(m.demande, Manque.somme(m)); if (!aPrendre) return;
    const parts = Object.entries(m.compl).filter(([, n]) => n > 0).map(([k, n]) => [+k, n]);
    const lignes = S.lignes.filter(l => (m.type === "plante" ? !l.mix && l.plante === id : l.mode === "pot" && l.pot === id));
    for (let k = lignes.length - 1; k >= 0 && aPrendre > 0; k--) {
      const l = lignes[k], n = Math.min(l.qte, aPrendre);
      let r = n;
      while (r > 0 && parts.length) {
        const part = parts[0], x = Math.min(part[1], r);
        const base = l.mix ? { mix: true, taille: l.taille, style: l.style || null, plante: l.plante } : { plante: l.plante };
        ajouterLigne(Object.assign(base, m.type === "plante" ? { plante: part[0], mode: l.mode, pot: l.pot } : { mode: "pot", pot: part[0] }, { qte: x, etiquette: !!l.etiquette }));
        part[1] -= x; r -= x; if (!part[1]) parts.shift();
      }
      l.qte -= n; aPrendre -= n;
    }
    S.lignes = S.lignes.filter(l => l.qte > 0); regrouper();
  }
  function ouvrirAjuster() {
    // les manques ouverts d'abord, puis ceux que notre equipe confirmera (on peut encore les completer)
    AJ.liste = manques().sort((a, c) => (a.garde ? 1 : 0) - (c.garde ? 1 : 0)).map(m => ({ type: m.type, id: m.item.variantId }));
    if (!AJ.liste.length) return;
    AJ.i = 0; AJ.m = null; $("#sp2-aj-manque").dataset.cle = "";
    rendreAjuster();
    if (typeof feuille.showModal === "function") { if (!feuille.open) feuille.showModal(); } else feuille.setAttribute("open", "");
    $(".tiroir-corps", feuille).scrollTop = 0;
  }
  function fermerAjuster() {
    appliquerAjuster();
    if (typeof feuille.close === "function" && feuille.open) feuille.close(); else feuille.removeAttribute("open");
    toutRendre(); garder(); annoncer(phraseTotal);
    focaliser(manques().length ? "#sp2-encart [data-ajuster]" : "#sp2-lignes .nom-ligne");
  }
  $("#sp2-aj-suiv").onclick = () => {
    if (AJ.i >= AJ.liste.length - 1) { fermerAjuster(); return; }
    appliquerAjuster(); AJ.i++; rendreAjuster(); toutRendre(); garder();
    $(".tiroir-corps", feuille).scrollTop = 0;
  };
  $("#sp2-aj-prec").onclick = () => { appliquerAjuster(); AJ.i = Math.max(0, AJ.i - 1); rendreAjuster(); toutRendre(); garder(); };
  $("#sp2-aj-fermer").onclick = fermerAjuster;
  feuille.addEventListener("cancel", e => { e.preventDefault(); fermerAjuster(); });           // Echap
  feuille.addEventListener("click", e => { if (e.target === feuille) fermerAjuster(); });
  $("#sp2-aj-manque").addEventListener("click", e => {
    if (!AJ.m) return;
    const act = Manque.clic(AJ.m, e, besoins()); if (!act) return;
    rendreAjuster();
    if (act === "garder") focaliser("#sp2-aj-manque [data-m='completer']");
    else if (act === "completer") focaliser("#sp2-aj-manque .vg-choix");
    else if (act === "tout") focaliser("#sp2-aj-manque .vg:nth-child(4) .vg-choix");
  });

  // ------------------------------------------------ la phrase de palier : seulement sous le tarif pro (pas de relance vers 25 ou 50)
  function lienPanier() {
    const q = new Map(), ajouter = (id, n) => { if (id) q.set(id, (q.get(id) || 0) + n); };
    S.lignes.filter(l => !l.mix).forEach(l => {
      const p = plante(l.plante), po = potDeLigne(l);
      ajouter(p.variantId, l.qte); if (po) ajouter(po.variantId, l.qte);     // jamais l'etiquette : un lien de panier ne porte pas son texte
    });
    return q.size ? `/cart/${[...q].map(([id, n]) => `${id}:${n}`).join(",")}?storefront=true` : (DON.boutique || "/collections/all");
  }
  // une seule phrase : sous le tarif pro, le premier palier ; a partir de la bascule, la confirmation
  function phrasePalier(c) {
    const q = c.pieces;
    if (q && c.tarifPublic) return { texte: "Tarif professionnel avec un email d'entreprise ou un SIRET." };
    if (q && q < MIN_PRO) return { texte: `Dès ${PREMIER.des} pièces : −${pct(PREMIER.taux)}`, boutique: !S.lignes.some(l => l.mix) };
    if (q >= BASCULE) return { texte: `Dès ${BASCULE} pièces : prix confirmé sous 24 h.` };
    return { texte: "" };
  }

  // ------------------------------------------------ le total, toujours a l'ecran (colonne sur ordinateur, barre sur telephone)
  function rendreTotal(c) {
    // le mix choisi mais pas encore dans la selection (il y entre au « Continuer ») : son prix, jamais 0 €
    const ap = !c.pieces && S.etape === "selection" && S.voie === "mix" && lignesMix().length ? calculer(lignesMix().map(l => Object.assign({ etiquette: S.persoDefaut }, l)), { mode: "une" }) : null;
    if (ap) c = ap;
    const q = c.pieces, ph = phrasePalier(c);
    $("#sp2-r-compte").textContent = q ? `${q} ${pl(q, "pièce")} · ${S.lignes.length} ${pl(S.lignes.length, "ligne")}` : "Aucune pièce";
    $("#sp2-r-lignes").innerHTML = S.lignes.map((l, i) => { const p = planteDe(l); return `<div><span>${l.qte} × ${ech(nomCourt(p.nom))}${l.mode === "sans" ? ", sans pot" : ""}</span><span>${eur(c.lignes[i] ? c.lignes[i].total : 0)}</span></div>`; }).join("");
    $("#sp2-r-brut").textContent = eur(c.brut);
    $("#sp2-r-etiq-l").textContent = `Étiquettes · ${c.nbEtiquettes} × ${eur(RG.etiquetteHT)}`;
    $("#sp2-r-etiq").textContent = c.etiquetteOfferte && c.nbEtiquettes ? "Offertes" : eur(c.etiquettes);
    $("#sp2-r-etiq").parentElement.classList.toggle("remise", !!(c.etiquetteOfferte && c.nbEtiquettes));
    $("#sp2-r-remise-l").textContent = c.taux ? `Remise ${pct(c.taux)}` : "Remise";
    $("#sp2-r-remise").textContent = c.remise ? eur(-c.remise) : eur(0);
    $("#sp2-r-remise").parentElement.classList.toggle("remise", c.remise > 0);
    $("#sp2-r-livr-l").textContent = S.livr.mode === "plusieurs" && q ? `Livraison · ${c.livraison.envois} ${pl(c.livraison.envois, "envoi")}` : "Livraison";
    $("#sp2-r-livr").textContent = eur(c.livraison.montant);
    $("#sp2-r-ht").textContent = eur(c.totalHT);
    $("#sp2-r-unite").textContent = q ? eurHT(c.parCadeau) : "·";
    $("#sp2-r-palier").textContent = ph.texte;
    const zs = $("#sp2-palier-sel");
    zs.hidden = !ph.texte;
    zs.innerHTML = ech(ph.texte) + (ph.boutique ? ` <a class="boutique" href="${ech(lienPanier())}" data-lien-boutique>Commander sur la boutique</a>` : "");
    $("#sp2-b-ht").textContent = eurHT(c.totalHT);
    $("#sp2-b-detail").textContent = q ? `${q} ${pl(q, "pièce")}` + (c.taux ? ` · remise ${pct(c.taux)}` : "") : "Aucune pièce";
    phraseTotal = q ? `Total ${eurHT(c.totalHT)} pour ${q} ${pl(q, "pièce")}${c.taux ? `, remise ${pct(c.taux)}` : ""}.` : "Aucune pièce.";
    annoncer(phraseTotal);
  }

  // ================================================= 2. ETIQUETTE
  const TYPES_ETIQ = { "logo-titre": "Logo et titre", "logo-texte": "Logo et petit texte", "logo": "Logo seul", "titre": "Titre seul", "titre-sous": "Titre et sous-titre" };
  // l'outil d'impression n'a qu'un gabarit sans logo (« texte ») : titre seul = sous-titre vide
  const TYPE_API = { "logo-titre": "logo-titre", "logo-texte": "logo-texte", "logo": "logo", "titre": "texte", "titre-sous": "texte" };
  const AVEC_TITRE = ["logo-titre", "titre", "titre-sous"], AVEC_SOUS = ["logo-texte", "titre-sous"];
  const bat = { fichier: null, original: null, apercu: false, empreinte: null, taille: null, jeton: 0, dernier: null };
  const avecLogo = () => /^logo/.test(S.etiq.type);
  const nbPerso = () => S.lignes.filter(l => l.etiquette).reduce((s, l) => s + l.qte, 0);
  function etatPerso() {
    if (!S.lignes.length) return S.persoDefaut ? "toutes" : "aucune";
    const n = S.lignes.filter(l => l.etiquette).length;
    return n === S.lignes.length ? "toutes" : n === 0 ? "aucune" : "partiel";
  }
  let ajusterOuvert = false;
  function rendreEtiquette() {
    const e = etatPerso(), q = pieces(), n = nbPerso();
    $$("input[name='sp2-perso']").forEach(r => { r.checked = r.value === e; });
    $("#sp2-perso-etat").textContent = S.lignes.length && e === "partiel" ? `${n} ${pl(n, "pièce")} sur ${q} · ${offreEtiquette() ? "offertes" : eurHT(n * RG.etiquetteHT)}` : "";
    $("#sp2-ajuster").hidden = S.lignes.length < 2 && !ajusterOuvert;
    $("#sp2-ajuster").setAttribute("aria-expanded", String(ajusterOuvert));
    $("#sp2-ajuster").textContent = ajusterOuvert ? "Masquer" : "Ligne par ligne";
    const z = $("#sp2-par-ligne");
    z.hidden = !ajusterOuvert || !S.lignes.length;
    if (!z.hidden) z.innerHTML = S.lignes.map(l => { const p = planteDe(l), { quoi } = descriptionLigne(l); return `<label class="case"><input type="checkbox" data-etiq-ligne="${l.id}" ${l.etiquette ? "checked" : ""}><span>${l.qte} × ${ech(p.nom)}<small>${ech(taille(p.t).nom)} · ${ech(quoi)}</small></span></label>`; }).join("");
    const actif = e !== "aucune";
    $("#sp2-atelier").hidden = !actif;
    $$("#sp2-types [data-type]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.type === S.etiq.type)));
    const t = S.etiq.type;
    $("#sp2-c-titre").hidden = !AVEC_TITRE.includes(t);
    $("#sp2-c-sous").hidden = !AVEC_SOUS.includes(t);
    $("#sp2-l-sous").textContent = t === "logo-texte" ? "Petit texte sous le logo" : "Sous-titre";
    $("#sp2-c-logo").hidden = !avecLogo();
    $("#sp2-par-dest-bloc").hidden = !S.etiq.parDest;
    if (S.etiq.logoNom && !bat.fichier && avecLogo()) { const nz = $("#sp2-logo-note"); if (!nz.textContent) { nz.className = "note alerte"; nz.textContent = `Redéposez votre logo « ${S.etiq.logoNom} ».`; } }
    if (actif) majVitrine();
    rendreChoixEtiquette();
  }
  // Point 6 du strategie : un logo (ou les textes par destinataire) sans fichier ne part jamais au paiement sans un choix
  // clair du client. Au « Continuer » de l'etiquette : « Deposer le logo », « Titre seul » ou « Je l'envoie apres » (et
  // « Deposer le fichier », « Texte commun » ou « Je l'envoie apres » pour les textes). Au recapitulatif, le meme choix
  // colle au bouton tant que le paiement serait immediat.
  let choixDemande = false;
  const logoEnAttente = () => etatPerso() !== "aucune" && avecLogo() && !bat.fichier && !S.etiq.logoApres;
  const textesEnAttente = () => etatPerso() !== "aucune" && !!S.etiq.parDest && !adr.fichier && !S.etiq.textesApres;
  const etiquetteEnAttente = () => logoEnAttente() || textesEnAttente();
  function htmlChoixEtiquette() {
    const q = (texte, boutons) => `<div class="choix-etiq-q"><p>${texte}</p><div class="actions">${boutons.map(([k, lib], i) => `<button type="button" class="bouton${i ? " contour" : ""}" data-choix-etiq="${k}">${lib}</button>`).join("")}</div></div>`;
    return (logoEnAttente() ? q("Votre logo n'est pas encore déposé.", [["logo-deposer", "Déposer le logo"], ["titre-seul", "Titre seul"], ["logo-apres", "Je l'envoie après"]]) : "")
      + (textesEnAttente() ? q("Le fichier des textes n'est pas encore déposé.", [["textes-deposer", "Déposer le fichier"], ["texte-commun", "Texte commun"], ["textes-apres", "Je l'envoie après"]]) : "");
  }
  function rendreChoixEtiquette() {
    const h = htmlChoixEtiquette();
    if (!h) choixDemande = false;
    const poser = (z, v) => { if (z.dataset.h !== v) { z.dataset.h = v; z.innerHTML = v; } z.hidden = !v; };
    poser($("#sp2-choix-etiq"), choixDemande ? h : "");
    poser($("#sp2-choix-etiq-r"), S.etape === "recap" && payerParCarte() ? h : "");
  }
  function montrerChoixEtiquette() {
    rendreChoixEtiquette();
    const z = S.etape === "recap" ? $("#sp2-choix-etiq-r") : $("#sp2-choix-etiq");
    if (z.hidden) return;
    z.scrollIntoView({ block: "center", behavior: calme ? "auto" : "smooth" });
    const b = z.querySelector("button"); if (b) b.focus({ preventScroll: true });
    annoncer(z.querySelector("p").textContent);
  }
  racine.addEventListener("click", e => {
    const b = e.target.closest("[data-choix-etiq]"); if (!b) return;
    const k = b.dataset.choixEtiq, auRecap = S.etape === "recap", titre = () => !!String(S.etiq.titre || "").trim();
    if (k === "logo-deposer" || k === "textes-deposer") {
      if (auRecap) aller("etiquette", { retour: true });
      const inp = k === "logo-deposer" ? $("#sp2-logo") : $("#sp2-dest-e");
      const c = inp.closest(".champ"); if (c) c.scrollIntoView({ block: "center", behavior: calme ? "auto" : "smooth" });
      inp.focus({ preventScroll: true }); inp.click();
      return;
    }
    if (k === "titre-seul") { S.etiq.type = "titre"; programmerBAT(0); if (auRecap && !titre()) aller("etiquette", { retour: true }); }
    if (k === "logo-apres") S.etiq.logoApres = true;
    if (k === "texte-commun") { S.etiq.parDest = false; $("#sp2-par-dest").checked = false; afficherAdresses(adr.lu); }
    if (k === "textes-apres") S.etiq.textesApres = true;
    garder();
    if (S.etape !== "etiquette") { toutRendreTotal(); if (etiquetteEnAttente()) montrerChoixEtiquette(); else focaliser("#sp2-envoyer"); return; }
    rendreEtiquette();
    if (k === "titre-seul" && !titre()) { $("#sp2-titre").focus(); return; }         // un titre d'abord, puis « Continuer »
    if (etiquetteEnAttente()) montrerChoixEtiquette(); else suivant();              // le client avait demande a continuer
  });
  $$("input[name='sp2-perso']").forEach(r => r.addEventListener("change", () => {
    const v = r.value === "toutes";
    S.persoDefaut = v; S.lignes.forEach(l => { l.etiquette = v; }); regrouper(); toutRendre(); garder();
  }));
  $("#sp2-ajuster").onclick = () => { ajusterOuvert = !ajusterOuvert; rendreEtiquette(); };
  $("#sp2-par-ligne").addEventListener("change", e => {
    const id = +e.target.dataset.etiqLigne; if (!id) return;
    const l = S.lignes.find(x => x.id === id); if (!l) return;
    l.etiquette = e.target.checked; toutRendre(); garder();
    const c = $(`#sp2-par-ligne [data-etiq-ligne="${id}"]`); if (c) c.focus({ preventScroll: true });
  });
  $("#sp2-types").addEventListener("click", e => { const b = e.target.closest("[data-type]"); if (!b) return; S.etiq.type = b.dataset.type; garder(); rendreEtiquette(); programmerBAT(0); });
  [["#sp2-titre", "titre"], ["#sp2-sous", "sous"], ["#sp2-mot", "mot"]].forEach(([id, k]) => {
    const el = $(id); el.value = S.etiq[k] || "";
    el.addEventListener("input", () => { S.etiq[k] = el.value; garder(); if (k !== "mot") programmerBAT(); });
  });
  $("#sp2-par-dest").checked = !!S.etiq.parDest;
  $("#sp2-par-dest").addEventListener("change", e => { S.etiq.parDest = e.target.checked; garder(); rendreEtiquette(); afficherAdresses(adr.lu); rendreLivraison(); });

  function majVitrine() {
    // l'apercu suit la selection : ses tailles personnalisees, sinon ses tailles, sinon la taille choisie ; onglets seulement s'il y en a plusieurs
    const avecRef = TAILLES.filter(x => REF[x.t]);
    const perso = avecRef.filter(x => S.lignes.some(l => l.etiquette && planteDe(l).t === x.t));
    const presentes = avecRef.filter(x => S.lignes.some(l => planteDe(l).t === x.t));
    const liste = perso.length ? perso : presentes.length ? presentes : avecRef.filter(x => x.t === S.taille).concat(avecRef).slice(0, 1);
    if (!liste.length) { $("#sp2-vitrine").hidden = true; return; }
    $("#sp2-vitrine").hidden = false;
    if (!bat.taille || !liste.some(x => x.t === bat.taille)) bat.taille = (liste.find(x => x.t === "S") || liste[0]).t;
    const zt = $("#sp2-v-tailles"), cle = liste.map(x => x.t).join(",");
    if (zt.dataset.cle !== cle) { zt.dataset.cle = cle; zt.innerHTML = liste.map(x => `<button type="button" data-t="${x.t}">${x.nom}</button>`).join(""); }
    $$("#sp2-v-tailles [data-t]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.t === bat.taille)));
    zt.hidden = liste.length < 2;
    const photo = $("#sp2-photo");
    if (photo.getAttribute("src") !== REF[bat.taille].photo) photo.src = REF[bat.taille].photo;
  }
  $("#sp2-v-tailles").addEventListener("click", e => { const b = e.target.closest("[data-t]"); if (!b) return; bat.taille = b.dataset.t; majVitrine(); programmerBAT(0); });

  // webp, gif, avif, bmp, svg... : le navigateur l'affiche, on le redessine en PNG pour l'outil d'impression
  function versPNG(f) {
    return new Promise((ok, ko) => {
      const url = URL.createObjectURL(f), img = new Image();
      img.onload = () => {
        try {
          const w0 = img.naturalWidth || 1000, h0 = img.naturalHeight || 1000, k = Math.min(1, 1200 / Math.max(w0, h0));
          const c = document.createElement("canvas"); c.width = Math.max(1, Math.round(w0 * k)); c.height = Math.max(1, Math.round(h0 * k));
          c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(b => { URL.revokeObjectURL(url); b ? ok(new File([b], "logo.png", { type: "image/png" })) : ko(new Error("png")); }, "image/png");
        } catch (err) { URL.revokeObjectURL(url); ko(err); }
      };
      img.onerror = () => { URL.revokeObjectURL(url); ko(new Error("illisible")); };
      img.src = url;
    });
  }
  const REFUS_LOGO = "Merci de nous envoyer votre logo en PNG ou JPEG.";
  $("#sp2-logo").addEventListener("change", async e => {
    const f = e.target.files && e.target.files[0]; if (!f) return;
    const note = $("#sp2-logo-note"), zone = $("#sp2-logo-zone");
    const ext = ((f.name.match(/\.([a-z0-9]+)$/i) || [])[1] || "").toLowerCase();
    const refuser = () => { note.className = "note alerte"; note.textContent = REFUS_LOGO; e.target.value = ""; };
    note.className = "note"; note.textContent = "";
    const natif = /^image\/(png|jpeg)$/.test(f.type) || ["png", "jpg", "jpeg"].includes(ext);
    let logo = natif ? f : null;
    if (!natif) {
      try { const png = await versPNG(f); logo = new File([png], (f.name.replace(/\.[a-z0-9]+$/i, "") || "logo") + ".png", { type: "image/png" }); }
      catch (err) { logo = null; }
    }
    if (!logo) return refuser();                                   // ai, eps, pdf, psd, tiff... : l'impression est automatique, on ne les retravaille pas
    bat.fichier = logo; bat.original = natif ? null : f; bat.empreinte = null; bat.dernier = null; bat.apercu = true;
    S.etiq.logoNom = f.name; garder(); rendreChoixEtiquette();
    zone.innerHTML = `<b>${ech(f.name)}</b><br>Remplacer`;
    if (logo.size > 15 * 1024 * 1024) { note.className = "note alerte"; note.textContent = `Fichier de ${(logo.size / 1048576).toFixed(0)} Mo : nous vous le redemanderons si besoin.`; }
    if (!E) { note.textContent = "Aperçu indisponible : le bon à tirer suivra."; return; }
    $("#sp2-attente").textContent = "Préparation du logo…";
    try {
      const d = await E.deposerLogo(logo);
      if (bat.fichier !== logo) return;
      bat.empreinte = d.empreinte;
      if (d.petit) { note.className = "note alerte"; note.textContent = `Logo petit (${d.largeur} × ${d.hauteur} px) : une version plus grande sera plus nette.`; }
    } catch (err) {
      if (err && err.message === "illisible") {                      // un PNG ou un JPEG illisible ne part pas
        bat.fichier = null; bat.original = null; S.etiq.logoNom = ""; garder(); rendreChoixEtiquette();
        zone.innerHTML = `<b>Déposer votre logo</b><br>PNG ou JPEG`;
        refuser(); programmerBAT(0); return;
      }
      note.className = "note"; note.textContent = "Aperçu indisponible : le bon à tirer suivra.";
    }
    programmerBAT(0);
  });
  // le zoom se cale sur l'etiquette : on repere sa place dans le calque (pixels opaques)
  function centrerZoom(img) {
    try {
      const c = document.createElement("canvas"), l = 200, h = Math.round(200 * img.naturalHeight / img.naturalWidth);
      c.width = l; c.height = h; const x = c.getContext("2d"); x.drawImage(img, 0, 0, l, h);
      const d = x.getImageData(0, 0, l, h).data; let x0 = l, y0 = h, x1 = -1, y1 = -1;
      for (let y = 0; y < h; y++) for (let i = 0; i < l; i++) if (d[(y * l + i) * 4 + 3] > 60) { x0 = Math.min(x0, i); x1 = Math.max(x1, i); y0 = Math.min(y0, y); y1 = Math.max(y1, y); }
      if (x1 < 0) return;
      const s = $("#sp2-scene");
      s.style.setProperty("--ox", `${((x0 + x1) / 2 / l * 100).toFixed(1)}%`); s.style.setProperty("--oy", `${((y0 + y1) / 2 / h * 100).toFixed(1)}%`);
    } catch (e) { /* reperage impossible : le cadrage garde sa position par defaut */ }
  }
  const ICONE_ENTIER = `<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 8V3h5M12 3h5v5M17 12v5h-5M8 17H3v-5"/></svg>`;
  const ICONE_CADRE = `<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 3v5H3M17 8h-5V3M12 17v-5h5M3 12h5v5"/></svg>`;
  function majCadrage() {
    const sc = $("#sp2-scene"), b = $("#sp2-zoom"), entier = sc.classList.contains("entier");
    b.innerHTML = entier ? ICONE_CADRE : ICONE_ENTIER;
    b.setAttribute("aria-label", entier ? "Revenir sur l'étiquette" : "Voir la photo entière");
    b.setAttribute("aria-pressed", String(entier));
  }
  const basculerCadrage = () => { $("#sp2-scene").classList.toggle("entier"); majCadrage(); };
  $("#sp2-zoom").addEventListener("click", e => { e.stopPropagation(); basculerCadrage(); });
  $("#sp2-scene").addEventListener("click", basculerCadrage);
  majCadrage();
  let minuteurBAT = null;
  function programmerBAT(delai) { clearTimeout(minuteurBAT); minuteurBAT = setTimeout(majBAT, delai == null ? 600 : delai); }
  async function majBAT() {
    const t = S.etiq.type, jeton = ++bat.jeton;
    const calque = $("#sp2-calque"), attente = $("#sp2-attente"), note = $("#sp2-bat-note");
    note.textContent = ""; note.className = "note";
    if (etatPerso() === "aucune" || !REF[bat.taille] || !E) return;
    const titre = AVEC_TITRE.includes(t) ? (S.etiq.titre || "").trim() : "";
    const sous = AVEC_SOUS.includes(t) ? (S.etiq.sous || "").trim() : "";
    if (avecLogo() && !bat.empreinte) {
      calque.hidden = true;
      attente.textContent = bat.fichier ? "Aperçu indisponible" : "Déposez votre logo";
      return;
    }
    if (TYPE_API[t] === "texte" && !titre && !sous) { calque.hidden = true; attente.textContent = t === "titre" ? "Écrivez votre titre" : "Écrivez votre texte"; return; }
    // l'etiquette precedente reste visible pendant la mise en page : jamais de transparence,
    // sinon l'etiquette d'origine de la photo apparait dessous
    attente.textContent = "Mise en page…";
    const ref = REF[bat.taille];
    try {
      const r = await E.calque({ taille: bat.taille, titre, sousTitre: sous, empreinte: bat.empreinte, type: TYPE_API[t], skuPlante: ref.skuPlante, skuPot: ref.skuPot });
      if (jeton !== bat.jeton) return;
      await new Promise(ok => { calque.onload = calque.onerror = () => ok(); calque.src = r.url; if (calque.complete && calque.naturalWidth) ok(); });
      if (jeton !== bat.jeton) return;
      if (!calque.naturalWidth) throw new Error("calque non chargé");
      calque.hidden = false; attente.textContent = "";
      centrerZoom(calque);
      bat.dernier = Object.assign({ taille: bat.taille, photo: ref.photo }, r);
      const coupes = [];
      // l'outil d'impression met le titre en capitales : « hello » devient « HELLO », ce n'est pas une coupure.
      // On ne signale que ce qui manque vraiment une fois la casse et les espaces mis de cote.
      const net = x => String(x || "").toLocaleUpperCase("fr-FR").replace(/\s+/g, " ").trim();
      if (titre && net(r.titreImprime) !== net(titre)) coupes.push(`« ${r.titreImprime} »`);
      if (sous && net(r.sousTitreImprime) !== net(sous)) coupes.push(`« ${r.sousTitreImprime} »`);
      if (coupes.length) { note.className = "note alerte"; note.textContent = `Trop long, imprimé : ${coupes.join(" et ")}.`; }
    } catch (err) {
      if (jeton !== bat.jeton) return;
      calque.hidden = true; attente.textContent = "";
      note.textContent = "Aperçu indisponible : le bon à tirer suivra.";
    }
  }

  // ================================================= 3. LIVRAISON
  let promesseXLSX = null;
  const chargerXLSX = () => promesseXLSX || (promesseXLSX = new Promise((ok, ko) => {
    if (window.XLSX) return ok(window.XLSX);
    const s = document.createElement("script"); s.src = DON.xlsx; s.async = true;
    s.onload = () => (window.XLSX ? ok(window.XLSX) : ko(new Error("xlsx")));
    s.onerror = () => { promesseXLSX = null; ko(new Error("xlsx")); };
    document.head.appendChild(s);
  }));
  const CHAMPS_LIVR = [["#sp2-l-nom", "nom"], ["#sp2-l-adresse", "adresse"], ["#sp2-l-cp", "cp"], ["#sp2-l-ville", "ville"], ["#sp2-envois", "envois"]];
  CHAMPS_LIVR.forEach(([id, k]) => {
    const el = $(id); el.value = S.livr[k] || "";
    el.addEventListener("input", () => { S.livr[k] = el.value; garder(); if (k === "cp" || k === "envois") { majLivraisonNotes(); toutRendreTotal(); } });
  });
  $$("input[name='sp2-livr']").forEach(r => r.addEventListener("change", () => { S.livr.mode = r.value; garder(); rendreLivraison(); toutRendreTotal(); if (adr.octets) verifierFichier(); }));
  // date de livraison : avant le..., entre le... et le..., ou sans date precise (dateSouhaitee reste la date limite)
  $("#sp2-date").min = aujourdhui(); $("#sp2-date-debut").min = aujourdhui();
  $("#sp2-date").value = S.livr.date || ""; $("#sp2-date-debut").value = S.livr.dateDebut || "";
  const poserDates = () => {
    if (S.livr.dateMode === "periode" && S.livr.dateDebut && S.livr.date && S.livr.dateDebut > S.livr.date) {     // dates inversees : on les remet dans l'ordre
      [S.livr.dateDebut, S.livr.date] = [S.livr.date, S.livr.dateDebut];
      $("#sp2-date").value = S.livr.date; $("#sp2-date-debut").value = S.livr.dateDebut;
    }
    garder(); majLivraisonNotes();
  };
  ["input", "change"].forEach(ev => {
    $("#sp2-date").addEventListener(ev, e => { S.livr.date = e.target.value; if (ev === "change") poserDates(); else { garder(); majLivraisonNotes(); } });
    $("#sp2-date-debut").addEventListener(ev, e => { S.livr.dateDebut = e.target.value; if (ev === "change") poserDates(); else garder(); });
  });
  $("#sp2-date-mode").addEventListener("click", e => { const b = e.target.closest("[data-mode]"); if (!b) return; S.livr.dateMode = b.dataset.mode; garder(); rendreLivraison(); });
  $("#sp2-date-note").addEventListener("click", e => {
    const b = e.target.closest("[data-date]"); if (!b) return;
    S.livr.date = b.dataset.date; $("#sp2-date").value = S.livr.date; garder(); majLivraisonNotes(); $("#sp2-date").focus();
  });
  function rendreLivraison() {
    $$("input[name='sp2-livr']").forEach(r => { r.checked = r.value === S.livr.mode; });
    $("#sp2-bloc-une").hidden = S.livr.mode !== "une";
    $("#sp2-bloc-plusieurs").hidden = S.livr.mode !== "plusieurs";
    const dm = S.livr.dateMode || "precise";
    $$("#sp2-date-mode [data-mode]").forEach(x => x.setAttribute("aria-pressed", String(x.dataset.mode === dm)));
    $("#sp2-dates").hidden = dm === "auPlusVite";
    $("#sp2-c-debut").hidden = dm !== "periode";
    $("#sp2-date-l").textContent = dm === "periode" ? "au" : "Le";
    const c = calcul();
    const ch = $("#sp2-envois");
    $("#sp2-c-envois").hidden = !!adr.res;
    if (document.activeElement !== ch) ch.value = adr.res ? adr.res.envois : (S.livr.envois || "");
    ch.placeholder = String(pieces() || "");
    majLivraisonNotes();
  }
  function majLivraisonNotes() {
    const zc = $("#sp2-cp-note");
    zc.className = "note"; zc.textContent = "";
    if (S.livr.mode === "une" && String(S.livr.cp || "").trim().length >= 4 && horsZone()) { zc.className = "note alerte"; zc.textContent = "Hors zone de livraison : tarif confirmé sous 24 h."; }
    const zd = $("#sp2-date-note"), d = etatDate();
    zd.className = "note";
    if (d.vide) { zd.textContent = S.livr.dateMode === "auPlusVite" ? `Livraison vers le ${dateLongue(livraisonAuPlusVite())}, une semaine de préparation après votre règlement.` : ""; }
    else if (d.passee) { zd.className = "note alerte"; zd.innerHTML = `Date passée. <button type="button" class="lien" data-date="${d.auPlusTot}">Au plus tôt : ${ech(dateLongue(d.auPlusTot))}</button>`; }
    else if (d.proche) { zd.className = "note alerte"; zd.innerHTML = `Date proche : notre équipe vous confirme sous 24&nbsp;h. <button type="button" class="lien" data-date="${d.auPlusTot}">Délai habituel : ${ech(dateLongue(d.auPlusTot))}</button>`; }
    else zd.textContent = `Stock réservé dès ${paiementEffectif() === "virement" ? "réception du virement" : "votre paiement"}.`;   // le paiement réserve le stock (Charles, 01/10)
  }
  // le fichier des destinataires : depose a l'etape Etiquette (un texte par destinataire) ou a la Livraison, c'est le
  // meme. A une seule adresse, seuls les noms et les textes comptent ; en differents points, les adresses sont exigees.
  async function verifierFichier() {
    if (!adr.octets) return;
    let res;
    try { const X = await chargerXLSX(); res = A.lire(adr.octets, adr.fichier.name, X, { sansAdresse: S.livr.mode !== "plusieurs" }); }
    catch (err) { res = { ok: false, fatal: err && err.message === "xlsx" ? "Vérification indisponible." : "Fichier illisible : enregistrez-le en Excel ou en CSV." }; }
    adr.res = res.ok ? res : null; adr.lu = res;
    afficherAdresses(res); rendreLivraison(); toutRendreTotal();
  }
  $$("[data-dest]").forEach(inp => inp.addEventListener("change", async e => {
    const f = e.target.files && e.target.files[0]; if (!f) return;
    $$("[data-dest-zone]").forEach(z => { z.innerHTML = `<b>${ech(f.name)}</b><br>Vérification…`; });
    $$("[data-dest]").forEach(x => { if (x !== e.target) x.value = ""; });
    adr.fichier = f; adr.octets = null; rendreChoixEtiquette();
    try { adr.octets = new Uint8Array(await f.arrayBuffer()); } catch (err) {}
    if (adr.octets) await verifierFichier();
    else { adr.res = null; adr.lu = { ok: false, fatal: "Fichier illisible : enregistrez-le en Excel ou en CSV." }; afficherAdresses(adr.lu); }
    $$("[data-dest-zone]").forEach(z => { z.innerHTML = `<b>${ech(f.name)}</b><br>Remplacer`; });
  }));
  const texteEtiquettes = res => (!res.colonnesTexte
    ? "Aucune colonne « Titre de l'étiquette » dans ce fichier : partez du modèle Excel."
    : `${res.nbTextes} ${pl(res.nbTextes, "texte")} d'étiquette ${pl(res.nbTextes, "lu")}` + (res.envois > res.nbTextes ? `, ${res.envois - res.nbTextes} avec le texte commun.` : "."));
  function afficherAdresses(res) {
    const zs = $$("[data-dest-resultat]");
    let h = "";
    if (res && !res.ok) h = `<div class="fichier-resume ko"><b>Fichier non lu.</b> ${ech(res.fatal)} Nous le reprendrons ensemble. <button type="button" class="lien" data-retirer>Retirer</button></div>`;
    else if (res) {
      const pb = res.lignes.filter(l => l.erreurs.length || l.alertes.length), prets = res.envois - res.nbErreurs, q = pieces();
      h = `<div class="fichier-resume ${res.nbErreurs ? "" : "ok"}"><b>${res.envois} ${pl(res.envois, "destinataire")} dans votre fichier</b> · ${prets} ${pl(prets, "prêt")}`
        + (res.nbErreurs ? ` · <span class="rouge">${res.nbErreurs} à corriger</span>` : "") + (res.nbAlertes ? ` · ${res.nbAlertes} à vérifier` : "")
        + ` · <button type="button" class="lien" data-retirer>Retirer</button></div>`;
      if (pb.length) h += `<div class="table-scroll"><table class="erreurs"><thead><tr><th>Ligne</th><th>Destinataire</th><th>À revoir</th></tr></thead><tbody>`
        + pb.slice(0, 60).map(l => { const v = l.valeurs; return `<tr class="${l.erreurs.length ? "err" : "alr"}"><td>${l.numero}</td><td>${ech((v.prenom + " " + v.nom).trim() || v.societe || v.titre || "?")}</td><td>${ech(l.erreurs.concat(l.alertes).join(" · "))}</td></tr>`; }).join("")
        + `</tbody></table></div><p class="note">Nous corrigerons ensemble avant l'expédition.</p>`;
      if (q && res.pieces !== q) h += `<p class="note alerte">Fichier : ${res.pieces} ${pl(res.pieces, "pièce")}, sélection : ${q}.</p>`;
      if (S.etiq.parDest) h += `<p class="note${res.colonnesTexte ? "" : " alerte"}" data-textes>${ech(texteEtiquettes(res))}</p>`;
    }
    zs.forEach(z => { if (z.dataset.h !== h) { z.dataset.h = h; z.innerHTML = h; } });
  }
  $$("[data-dest-resultat]").forEach(z => z.addEventListener("click", e => {
    if (!e.target.closest("[data-retirer]")) return;
    adr.res = null; adr.fichier = null; adr.octets = null; adr.lu = null; rendreChoixEtiquette();
    $$("[data-dest]").forEach(x => { x.value = ""; });
    $$("[data-dest-zone]").forEach(x => { x.innerHTML = `<b>Déposer le fichier</b><br>Excel ou CSV`; });
    afficherAdresses(null); rendreLivraison(); toutRendreTotal();
    const d = S.etape === "etiquette" ? $("#sp2-dest-e") : $("#sp2-dest"); if (d) d.focus({ preventScroll: true });
  }));

  // ================================================= 4. COORDONNEES
  const CHAMPS_CONTACT = [["#sp2-societe", "contact", "societe"], ["#sp2-nom", "contact", "nom"], ["#sp2-email", "contact", "email"], ["#sp2-telephone", "contact", "telephone"],
    ["#sp2-ident", "ent", "ident"], ["#sp2-bc", "ent", "bc"], ["#sp2-f-adresse", "ent", "adresse"], ["#sp2-f-cp", "ent", "cp"], ["#sp2-f-ville", "ent", "ville"], ["#sp2-f-pays", "ent", "pays"],
    ["#sp2-occasion", null, "occasion"], ["#sp2-message", null, "message"]];
  CHAMPS_CONTACT.forEach(([id, g, k]) => {
    const el = $(id), o = g ? S[g] : S;
    if (o[k] != null && o[k] !== "") el.value = o[k];
    el.addEventListener("input", () => {
      o[k] = el.value; garder();
      const c = el.closest(".champ"); if (c && c.classList.contains("erreur")) { c.classList.remove("erreur"); el.removeAttribute("aria-invalid"); }
      if (k === "ident") { majIdent(); toutRendreTotal(); majNoteTarif(); }
      if (k === "email") { toutRendreTotal(); majNoteTarif(); }
      if (k === "societe" || k === "ident") programmerSuggestions();
    });
    if (el.tagName === "SELECT") el.addEventListener("change", () => { o[k] = el.value; garder(); });
  });
  $("#sp2-sans-siret").checked = !!S.ent.sansSiret;
  $("#sp2-sans-siret").addEventListener("change", e => { S.ent.sansSiret = e.target.checked; garder(); majIdent(); toutRendreTotal(); programmerSuggestions(); });
  $$("input[name='sp2-paiement']").forEach(r => r.addEventListener("change", () => { S.paiement = r.value; garder(); }));
  $("#sp2-fact-identique").addEventListener("change", e => { S.ent.factIdentique = e.target.checked; garder(); rendreCoordonnees(); if (!e.target.checked) $("#sp2-f-adresse").focus(); });
  const factIdentique = () => S.livr.mode === "une" && S.ent.factIdentique !== false;
  // verification dans l'annuaire public des entreprises (gratuit, sans jeton) : le resultat s'affiche, jamais bloquant
  const annuaire = {};                      // siren -> { etat : "attente" | "trouve" | "introuvable" | "erreur", u }
  let siretComplete = null;                 // SIRET du siege pose a partir d'un SIREN seul
  const sirenDe = id => (id.type === "siret" || id.type === "siren" ? id.valeur.slice(0, 9) : id.type === "tva" && /^FR/.test(id.valeur) ? id.valeur.slice(4) : "");
  function majIdent() {
    const z = $("#sp2-ident-note"), id = ident(), siren = sirenDe(id);
    z.className = "note"; z.textContent = "";
    if (!id.type) return;
    if (id.type === "inconnu" || (id.type === "siren" ? !id.sirenValide : !id.valide)) {
      // 14 chiffres faux : jamais « incomplet » (point 8 du strategie) ; seuls moins de 14 chiffres sont « incomplets »
      z.className = "note alerte";
      z.textContent = id.type === "tva" ? "Numéro de TVA incomplet ou invalide."
        : id.type === "siret" ? "Ce SIRET n'est pas valide."
        : id.type === "siren" ? "Ce SIREN n'est pas valide."
        : /^\d{1,13}$/.test(id.valeur) ? "Numéro incomplet (SIRET : 14 chiffres)." : "Ce numéro n'est pas valide.";
      return;
    }
    if (!/^\d{9}$/.test(siren)) { z.className = "note ok"; z.textContent = "TVA au bon format."; return; }       // TVA d'un autre pays : format seulement
    const a = annuaire[siren];
    if (!a) { z.textContent = "Vérification…"; chercherEntreprise(siren); return; }
    if (a.etat === "attente") { z.textContent = "Vérification…"; return; }
    if (a.etat === "introuvable") { z.textContent = "Numéro introuvable, vous pouvez continuer."; return; }
    if (a.etat === "erreur") { z.textContent = "Vérification indisponible, vous pouvez continuer."; return; }
    const u = a.u, nom = u.nom_complet || u.nom_raison_sociale || "";
    const et = (id.type === "siret" && (u.matching_etablissements || []).find(x => x.siret === id.valeur)) || u.siege || {};
    if (id.type === "siren" && /^\d{14}$/.test(et.siret || "")) {              // un SIREN seul : complete par le SIRET du siege, visible et corrigeable
      siretComplete = et.siret; S.ent.ident = et.siret; $("#sp2-ident").value = et.siret; garder(); toutRendreTotal(); majIdent();
      return;
    }
    z.className = "note ok";
    z.textContent = (id.valeur === siretComplete ? `SIRET du siège : ${id.valeur.replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, "$1 $2 $3 $4")} · ` : "✓ ") + nom
      + (et.libelle_commune ? " · " + et.libelle_commune : "") + (et.etat_administratif === "F" ? " · fermé au répertoire" : "");
    if (!S.ent.adresse && !S.ent.cp && !S.ent.ville && et.code_postal) {       // adresse de facturation preremplie si elle est vide
      S.ent.adresse = String(et.adresse || "").replace(new RegExp("\\s*" + et.code_postal + ".*$"), "").trim(); S.ent.cp = et.code_postal; S.ent.ville = et.libelle_commune || "";
      ["adresse", "cp", "ville"].forEach(k => { $(`#sp2-f-${k}`).value = S.ent[k]; });
      garder();
    }
  }
  async function chercherEntreprise(siren) {
    annuaire[siren] = { etat: "attente" };
    try {
      if (typeof fetch !== "function") throw new Error("fetch");
      const arret = new AbortController(), m = setTimeout(() => arret.abort(), 5000);
      const r = await fetch(`https://recherche-entreprises.api.gouv.fr/search?q=${siren}&page=1&per_page=1`, { signal: arret.signal });
      clearTimeout(m);
      if (!r.ok) throw new Error("http " + r.status);
      const d = await r.json(), u = d && d.results && d.results[0];
      annuaire[siren] = u && (!u.siren || u.siren === siren) ? { etat: "trouve", u } : { etat: "introuvable" };
    } catch (e) { annuaire[siren] = { etat: "erreur" }; }
    if (sirenDe(ident()) === siren) majIdent();
  }
  // Point 3a du strategie : le SIRET propose a partir du nom de la societe, par le meme annuaire public (CORS ouvert,
  // 7 appels par seconde) : 300 ms apres la derniere frappe, 3 caracteres au moins, seul le nom tape part. Un toucher
  // remplit le SIRET du siege et l'adresse de facturation. Annuaire muet : rien ne s'affiche, la saisie reste libre.
  const sugg = { cache: {}, minuteur: null, arret: null, nom: "" };
  const cleNom = s => String(s || "").trim().replace(/\s+/g, " ").toLowerCase();
  const siretLisible = s => String(s).replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, "$1 $2 $3 $4");
  const villeDe = et => [et.code_postal, String(et.libelle_commune || "").toLowerCase().replace(/(^|[\s'-])\S/g, c => c.toUpperCase())].filter(Boolean).join(" ");
  const suggestionsUtiles = () => !ident().valide && !S.ent.sansSiret;
  function programmerSuggestions() {
    clearTimeout(sugg.minuteur);
    const nom = cleNom(S.contact.societe);
    if (nom.length < 3 || !suggestionsUtiles()) { rendreSuggestions(); return; }
    if (sugg.cache[nom]) { sugg.nom = nom; rendreSuggestions(); return; }
    sugg.minuteur = setTimeout(() => chercherSocietes(nom), 300);
  }
  async function chercherSocietes(nom) {
    sugg.nom = nom;
    if (sugg.arret) sugg.arret.abort();
    const arret = sugg.arret = new AbortController(), m = setTimeout(() => arret.abort(), 4000);
    try {
      if (typeof fetch !== "function") return;
      const r = await fetch(`https://recherche-entreprises.api.gouv.fr/search?q=${encodeURIComponent(nom)}&per_page=5`, { signal: arret.signal });
      if (!r.ok) return;
      const d = await r.json();
      sugg.cache[nom] = (d && Array.isArray(d.results) ? d.results : [])
        .filter(u => u && u.siege && /^\d{14}$/.test(u.siege.siret || "") && u.etat_administratif !== "C" && u.siege.etat_administratif !== "F").slice(0, 5);
    } catch (e) { return; }                                   // annuaire muet ou lent : aucun message
    finally { clearTimeout(m); }
    if (sugg.nom === nom) rendreSuggestions();
  }
  function rendreSuggestions() {
    const z = $("#sp2-suggestions"), nom = cleNom(S.contact.societe);
    const liste = suggestionsUtiles() && sugg.nom === nom && sugg.cache[nom] || [];
    const h = liste.length ? `<p class="sugg-t">D'après le nom de votre société :</p>` + liste.map(u => `<button type="button" class="sugg" data-siret="${u.siege.siret}"><b>${ech(u.nom_complet || u.nom_raison_sociale || "")}</b><span>SIRET ${siretLisible(u.siege.siret)}${villeDe(u.siege) ? " · " + ech(villeDe(u.siege)) : ""}</span></button>`).join("") : "";
    if (z.dataset.h !== h) { z.dataset.h = h; z.innerHTML = h; }
    z.hidden = !h;
  }
  $("#sp2-suggestions").addEventListener("click", e => {
    const b = e.target.closest("[data-siret]"); if (!b) return;
    const u = (sugg.cache[sugg.nom] || []).find(x => x.siege.siret === b.dataset.siret); if (!u) return;
    const et = u.siege;
    S.ent.ident = et.siret; $("#sp2-ident").value = et.siret; S.ent.sansSiret = false; $("#sp2-sans-siret").checked = false;
    annuaire[et.siret.slice(0, 9)] = { etat: "trouve", u };                  // deja verifie : pas de second appel
    if (/^\d{5}$/.test(et.code_postal || "") && !/NON-DIFFUSIBLE/i.test(et.adresse || "")) {  // la facture au siege, visible et modifiable
      S.ent.adresse = String(et.adresse || "").replace(new RegExp("\\s*" + et.code_postal + ".*$"), "").trim();
      S.ent.cp = et.code_postal; S.ent.ville = et.libelle_commune || ""; S.ent.pays = "France"; S.ent.factIdentique = false;
      ["adresse", "cp", "ville", "pays"].forEach(k => { $(`#sp2-f-${k}`).value = S.ent[k]; });
    }
    garder(); rendreCoordonnees(); toutRendreTotal();
    annoncer(`SIRET ${siretLisible(et.siret)} ajouté.`);
    if (!e.detail) $("#sp2-ident").focus();                  // au clavier seulement : pas de clavier qui surgit au telephone
  });
  // Point 11 du strategie : les champs facultatifs (telephone, reference, occasion, message) replies ; ouverts d'office
  // s'ils sont deja remplis, jamais les champs obligatoires
  let facultatifsOuverts = false;
  const facultatifsRemplis = () => !!(String(S.contact.telephone || "").trim() || String(S.ent.bc || "").trim() || S.occasion || String(S.message || "").trim());
  function rendreFacultatifs() {
    if (facultatifsRemplis()) facultatifsOuverts = true;          // une fois ouverts, ils le restent
    const ouvert = facultatifsOuverts;
    $("#sp2-facultatifs").hidden = !ouvert; $("#sp2-plus").hidden = ouvert;
    $("#sp2-plus").setAttribute("aria-expanded", String(ouvert));
  }
  $("#sp2-plus").addEventListener("click", () => { facultatifsOuverts = true; rendreFacultatifs(); $("#sp2-telephone").focus(); });
  function rendreCoordonnees() {
    const q = pieces(), pro = q >= MIN_PRO, multi = S.livr.mode === "plusieurs", virementOk = multi || q >= VIREMENT_DES;
    $("#sp2-ident-aide").textContent = pro ? "Pour le tarif professionnel." : (RG.remisePetitPro ? `Entreprises : −${pct(RG.remisePetitPro)} dès la première pièce.` : "Facultatif.");
    $("#sp2-c-sans-siret").hidden = !pro;
    $("#sp2-opt-carte").hidden = multi;
    $("#sp2-opt-virement").hidden = !virementOk;
    if (!multi && !virementOk && S.paiement === "virement") S.paiement = "carte";
    const eff = paiementEffectif();
    $$("input[name='sp2-paiement']").forEach(r => { r.checked = r.value === eff; });
    const pn = $("#sp2-paiement-note");
    pn.textContent = multi ? "Plusieurs adresses : règlement par virement." : virementOk ? "" : `Virement dès ${VIREMENT_DES} pièces.`;
    pn.hidden = !pn.textContent;
    $("#sp2-c-fact-identique").hidden = S.livr.mode !== "une";
    $("#sp2-fact-identique").checked = factIdentique();
    $("#sp2-fact-champs").hidden = factIdentique();
    majIdent();
    rendreFacultatifs();
    programmerSuggestions();
  }
  function coordonneesValides(focaliser) {
    let ok = true, premier = null;
    const verif = (id, cond) => {
      const c = $("#sp2-c-" + id), el = $("#sp2-" + id);
      c.classList.toggle("erreur", !cond);
      if (!cond) el.setAttribute("aria-invalid", "true"); else el.removeAttribute("aria-invalid");
      if (!cond && !premier) premier = el;
      ok = ok && cond;
    };
    verif("societe", !!String(S.contact.societe || "").trim());
    verif("nom", !!String(S.contact.nom || "").trim());
    verif("email", emailValide(S.contact.email));
    if (!ok && focaliser && premier) premier.focus();
    return ok;
  }

  // ================================================= 5. RECAPITULATIF
  // regle de Charles (30/09) : la carte est reservee a une seule adresse de livraison ; en differents points, virement,
  // meme sous 10 pieces. A une seule adresse : carte seulement sous VIREMENT_DES, puis au choix.
  function paiementEffectif() { return S.livr.mode === "plusieurs" ? "virement" : pieces() >= VIREMENT_DES ? S.paiement : "carte"; }
  // carte et rien a confirmer : on paie tout de suite (le devis part aussi par email)
  const payerParCarte = () => pieces() > 0 && !aConfirmer().length && paiementEffectif() === "carte";
  const libelleEnvoi = () => (pieces() && aConfirmer().length ? "Envoyer ma demande" : payerParCarte() ? "Payer par carte" : "Recevoir mon devis");
  function blocsRecap(c) {
    const e = etatPerso(), t = S.etiq.type, d = etatDate(), id = ident(), n = nbPerso();
    const sel = S.lignes.length ? S.lignes.map(l => { const { p, quoi } = descriptionLigne(l); return `${l.qte} × ${p.nom} (${taille(p.t).nom.toLowerCase()}, ${quoi})`; }).join("\n")
      + (S.lignes.some(l => l.mix) ? `\nComposition : notre équipe choisit ${S.lignes.some(l => l.mode === "mixpots") ? "les plantes et les pots" : "les plantes"}` : "") : "Aucune pièce";
    const etiq = e === "aucune" ? "Sans personnalisation" : [
      `${TYPES_ETIQ[t]} · ${n} ${pl(n, "pièce")}`,
      AVEC_TITRE.includes(t) && S.etiq.titre ? `Titre : « ${S.etiq.titre} »` : "",
      AVEC_SOUS.includes(t) && S.etiq.sous ? `${t === "logo-texte" ? "Petit texte" : "Sous-titre"} : « ${S.etiq.sous} »` : "",
      avecLogo() ? (bat.fichier ? `Logo : ${bat.fichier.name}` : S.etiq.logoApres ? "Logo : envoyé plus tard" : "Logo : non déposé") : "",
      S.etiq.parDest ? "Un texte par destinataire" + (adr.res ? ` · ${adr.res.nbTextes} ${pl(adr.res.nbTextes, "texte")} dans le fichier` : adr.fichier ? ` · ${adr.fichier.name}` : S.etiq.textesApres ? " · fichier envoyé plus tard" : " · fichier non déposé") : ""
    ].filter(Boolean).join("\n");
    const mot = S.etiq.mot ? `Mot : « ${S.etiq.mot} »` : "";
    let livr = S.livr.mode === "une"
      ? ["Une seule adresse de livraison", [S.livr.nom, S.livr.adresse, [S.livr.cp, S.livr.ville].filter(Boolean).join(" ")].filter(Boolean).join(", ")].filter(Boolean).join("\n")
      : `Différents points de livraison · ${nbEnvois()} ${pl(nbEnvois(), "envoi")}` + (adr.res ? `\nFichier : ${adr.res.envois} ${pl(adr.res.envois, "destinataire")}${adr.res.nbErreurs ? `, ${adr.res.nbErreurs} à corriger` : ""}` : adr.fichier ? `\nFichier : ${adr.fichier.name}` : "\nListe à suivre");
    livr += "\n" + (d.vide ? `Au plus vite, vers le ${dateLongue(livraisonAuPlusVite())}` : modeDate() === "periode" && dateValide(S.livr.dateDebut) ? `Du ${dateLongue(S.livr.dateDebut)} au ${dateLongue(S.livr.date)}` : `Le ${dateLongue(S.livr.date)}`);
    const coord = [S.contact.societe, S.contact.nom, S.contact.email, S.contact.telephone,
      id.valeur ? `${id.type === "tva" ? "TVA" : "SIRET"} ${id.valeur}` : (S.ent.sansSiret ? "Sans SIRET" : ""),
      S.ent.bc ? `Réf. ${S.ent.bc}` : "",
      factIdentique() ? "Facturation : même adresse que la livraison" : [S.ent.adresse, [S.ent.cp, S.ent.ville].filter(Boolean).join(" "), S.ent.pays && S.ent.pays !== "France" ? S.ent.pays : ""].filter(Boolean).join(", ")].filter(Boolean).join("\n");
    // le bloc Reglement dit toujours la meme chose que le bouton : « Envoyer ma demande » = apres confirmation
    const apres = pieces() && aConfirmer().length ? " après confirmation" : "";
    const regl = (paiementEffectif() === "virement" ? "Virement, facture après bon pour accord" : "Carte, lien de paiement") + apres;
    return [["selection", "Sélection", sel], ["etiquette", "Étiquette", [etiq, mot].filter(Boolean).join("\n")], ["livraison", "Livraison", livr], ["coordonnees", "Coordonnées", coord || "À compléter"], ["coordonnees", "Règlement", regl]];
  }
  function rendreRecap() {
    const c = calcul(), aC = aConfirmer();
    $("#sp2-recap").innerHTML = blocsRecap(c).map(([etape, titre, v]) => `<div class="recap-bloc"><span class="t">${titre}</span><span class="v">${ech(v)}</span><button type="button" class="lien" data-modifier="${etape}" aria-label="Modifier : ${titre}">Modifier</button></div>`).join("");
    const q = c.pieces;
    $("#sp2-recap-prix").innerHTML = [
      ["Plantes et pots", eur(c.brut)],
      [`Étiquettes · ${c.nbEtiquettes} × ${eur(RG.etiquetteHT)}`, c.etiquetteOfferte && c.nbEtiquettes ? "Offertes" : eur(c.etiquettes)],
      [c.taux ? `Remise ${pct(c.taux)}` : "Remise", c.remise ? eur(-c.remise) : eur(0)],
      [S.livr.mode === "plusieurs" && q ? `Livraison · ${c.livraison.envois} ${pl(c.livraison.envois, "envoi")}` : "Livraison", eur(c.livraison.montant)]
    ].map(([a, b]) => `<div class="ligne"><span>${ech(a)}</span><span>${b}</span></div>`).join("")
      + `<div class="ligne fort"><span>Total HT</span><span id="sp2-recap-ht">${eur(c.totalHT)}</span></div>`
      + `<div class="ligne"><span>TVA</span><span>${eur(c.tva)}</span></div>`
      + `<div class="ligne"><span>Total TTC</span><span>${eur(c.totalTTC)}</span></div>`
      + (q ? `<div class="ligne"><span>Par cadeau</span><span>${eurHT(c.parCadeau)}</span></div>` : "")
      + (c.etiquetteOfferte ? `<p class="note">Étiquette offerte pour toute commande réglée d'ici le ${ech(OFFRE.jusquau)}.</p>` : "")
      + (q && q < MIN_PRO ? `<p class="note">${ech(phrasePalier(c).texte)}${phrasePalier(c).boutique ? ` · <a href="${ech(lienPanier())}" data-lien-boutique>Commander sur la boutique</a>` : ""}</p>` : "");
    const z = $("#sp2-a-confirmer");
    z.hidden = !aC.length || !q;
    if (!z.hidden) z.innerHTML = `<b>Notre équipe vous confirme sous 24&nbsp;h ouvrées :</b><ul>${aC.map(k => `<li>${ech(LIB_AC[k]())}</li>`).join("")}</ul>`;
    if (!racine.classList.contains("sp2-envoi")) $("#sp2-envoyer").textContent = libelleEnvoi();
    $("#sp2-payer-sous").hidden = !payerParCarte();
    $("#sp2-essai").hidden = !!DON.reception;
    rendreChoixEtiquette();
  }
  $("#sp2-recap").addEventListener("click", e => { const b = e.target.closest("[data-modifier]"); if (b) aller(b.dataset.modifier, { retour: true }); });

  // ================================================= NAVIGATION
  const ETAPES = ["selection", "etiquette", "livraison", "coordonnees", "recap", "fin"];
  // point 8 du strategie (paiement_rapide.md) : « Continuer » partout, jamais « Recapitulatif » pour avancer
  const LIB_SUIVANT = { selection: "Continuer", etiquette: "Continuer", livraison: "Continuer", coordonnees: "Continuer" };
  const LIB_GO = LIB_SUIVANT;
  function aller(nom, opts) {
    opts = opts || {};
    if (!ETAPES.includes(nom)) nom = "selection";
    if (opts.retour !== undefined) retourRecap = !!opts.retour;
    if (nom === "recap" || nom === "fin") retourRecap = false;
    if (S.etape === "selection" && ETAPES.indexOf(nom) > 0) garderManques();         // « Continuer » garde les manques ouverts
    S.etape = nom;
    $$(".etape").forEach(e => e.classList.toggle("active", e.dataset.etape === nom));
    const i = ETAPES.indexOf(nom);
    $$(".fil button").forEach(b => {
      const k = ETAPES.indexOf(b.dataset.aller);
      if (b.dataset.aller === nom) b.setAttribute("aria-current", "step"); else b.removeAttribute("aria-current");
      b.classList.toggle("faite", nom !== "fin" && k < i);
    });
    $(".fil").hidden = nom === "fin";
    $$("[data-suivant]").forEach(b => { b.textContent = retourRecap ? "Retour au récapitulatif" : (LIB_SUIVANT[nom] || "Continuer"); });
    if (nom === "etiquette") { rendreEtiquette(); programmerBAT(0); }
    if (nom === "livraison") rendreLivraison();
    if (nom === "coordonnees") rendreCoordonnees();
    if (nom === "recap") rendreRecap();
    majBoutonsGo();
    if (!opts.silence && S.ouvert) {
      const tete = $(".fil") && !$(".fil").hidden ? $(".fil") : $(`.etape[data-etape="${nom}"]`);
      const r = tete.getBoundingClientRect();
      if (r.top < 60 || r.top > window.innerHeight * .5) window.scrollTo({ top: window.scrollY + r.top - 110, behavior: calme ? "auto" : "smooth" });
      const h = $(`.etape[data-etape="${nom}"] h3`); if (h) h.focus({ preventScroll: true });
    }
    if (nom !== "fin") garder();
  }
  let majBarre = () => {};
  function majBoutonsGo() {
    if (racine.classList.contains("sp2-envoi")) return;          // pendant l'envoi, les boutons gardent leur attente
    const nom = S.etape, go = $("#sp2-r-go"), bgo = $("#sp2-b-go");
    let t, tc;
    if (nom === "recap") { t = libelleEnvoi(); tc = payerParCarte() ? "Payer" : "Envoyer"; }
    else if (retourRecap) { t = "Retour au récapitulatif"; tc = "Récapitulatif"; }
    else { t = LIB_GO[nom] || "Continuer"; tc = "Continuer"; }
    go.textContent = t; bgo.textContent = tc;
    go.hidden = nom === "fin"; bgo.hidden = nom === "fin";
    const sansRetour = nom === "selection" || nom === "fin";
    $("#sp2-r-retour").hidden = sansRetour; $("#sp2-b-retour").hidden = sansRetour;
    majBarre();
  }
  // e : le clic (barre, colonne ou etape) ; au recapitulatif, c'est ce bouton-la qui passe en attente
  function suivant(e) {
    if (S.etape === "selection" && S.voie === "mix" && !S.lignes.some(l => l.mix)) {
      $("#sp2-mix-ajouter").click();                 // ajoute le mix, ou dit ce qui manque (modele de pot)
      if (!S.lignes.some(l => l.mix)) return;
    }
    if (S.etape === "selection" && !pieces()) { const n = $("#sp2-reste"); n.hidden = false; n.textContent = "Ajoutez au moins une plante."; return; }
    if (S.etape === "etiquette" && etiquetteEnAttente()) { choixDemande = true; montrerChoixEtiquette(); return; }   // point 6
    if (retourRecap) { aller("recap"); return; }
    const i = ETAPES.indexOf(S.etape);
    if (S.etape === "recap") { envoyer(null, e && e.currentTarget && e.currentTarget.nodeType === 1 ? e.currentTarget : null); return; }
    aller(ETAPES[Math.min(i + 1, ETAPES.indexOf("recap"))]);
  }
  $$("[data-suivant]").forEach(b => b.addEventListener("click", suivant));
  const precedent = () => { const i = ETAPES.indexOf(S.etape); aller(ETAPES[Math.max(0, i - 1)]); };
  $$("[data-precedent]").forEach(b => b.addEventListener("click", precedent));
  $("#sp2-r-retour").addEventListener("click", precedent);
  $("#sp2-b-retour").addEventListener("click", precedent);
  $$(".fil button").forEach(b => b.addEventListener("click", () => aller(b.dataset.aller, { retour: false })));
  $("#sp2-r-go").addEventListener("click", suivant);
  $("#sp2-b-go").addEventListener("click", suivant);
  $("#sp2-envoyer").addEventListener("click", e => envoyer(null, e.currentTarget));
  $("#sp2-devis-email").addEventListener("click", e => envoyer("email", e.currentTarget));
  racine.addEventListener("keydown", e => {
    // jamais d'envoi involontaire avec la touche Entree dans un champ
    if (e.key === "Enter" && e.target.tagName === "INPUT" && !["checkbox", "radio", "file"].includes(e.target.type) && !e.target.closest("#sp2-tiroir, #sp2-lignes")) e.preventDefault();
  });

  // ------------------------------------------------ tout redessiner apres un changement de selection
  function toutRendreTotal() { const c = calcul(); rendreTotal(c); if (S.etape === "recap") rendreRecap(); majBoutonsGo(); return c; }
  function toutRendre() {
    const c = calcul();
    rendrePlantes(); rendreLignes(c); rendreTotal(c);
    if (S.etape === "etiquette") rendreEtiquette();
    if (S.etape === "livraison") rendreLivraison();
    if (S.etape === "coordonnees") rendreCoordonnees();
    if (S.etape === "recap") rendreRecap();
    majBoutonsGo();
  }

  // ================================================= ENVOI
  const enBase64 = blob => new Promise((ok, ko) => { const r = new FileReader(); r.onload = () => ok(String(r.result).split(",")[1] || ""); r.onerror = ko; r.readAsDataURL(blob); });
  const nouvelId = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
  // Les fichiers joints, dans l'ordre de priorite sous la limite de 22 Mo : le logo TEL QUE DEPOSE (jamais la version
  // reduite de l'apercu), le fichier d'adresses D'ORIGINE, les documents du projet, la version verifiee des adresses,
  // puis l'apercu de l'etiquette. Chaque fichier porte son role ; etiquette.logo et livraison.destinataires donnent l'index
  // du logo d'origine et de la version verifiee (null si elle n'existe pas ou ne tient pas).
  async function preparerFichiers(avecDocs) {
    const liste = []; let total = 0;
    const ajouter = async (blob, nom, type, role) => {
      if (!blob || !blob.size || total + blob.size > MAX_FICHIERS) return null;
      total += blob.size;
      liste.push({ nom, type: type || blob.type || "application/octet-stream", role, base64: await enBase64(blob) });
      return liste.length - 1;
    };
    let logo = null, destinataires = null;
    if (bat.fichier && avecLogo() && etatPerso() !== "aucune") logo = await ajouter(bat.fichier, bat.fichier.name, bat.fichier.type, "logo");
    // le fichier part en differents points de livraison, ou pour les textes d'etiquette a une seule adresse
    const avecFichier = S.livr.mode === "plusieurs" || (S.etiq.parDest && etatPerso() !== "aucune");
    if (avecFichier && adr.fichier) await ajouter(adr.fichier, adr.fichier.name, adr.fichier.type, "origine");
    if (logo !== null && bat.original) await ajouter(bat.original, bat.original.name, bat.original.type, "document");   // l'image d'origine d'un logo converti en PNG
    for (const f of (avecDocs || [])) await ajouter(f, f.name, f.type, "document");
    if (avecFichier && adr.res) {
      try { const X = await chargerXLSX(); destinataires = await ajouter(new Blob([A.versXLSX(adr.res, X)], { type: XLSX_TYPE }), "destinataires-verifies.xlsx", XLSX_TYPE, "destinataires"); } catch (e) {}
    }
    if (bat.dernier && etatPerso() !== "aucune" && E) {
      try { const jpg = await E.composer(bat.dernier.photo, bat.dernier.url, 900); await ajouter(await (await fetch(jpg)).blob(), "apercu-etiquette.jpg", "image/jpeg", "apercu"); } catch (e) {}
    }
    return { liste, logo, destinataires };
  }
  const ids = {};
  async function charge(type, extra) {
    extra = extra || {};
    const c = calcul(), id = ident(), t = S.etiq.type;
    const f = type === "rappel" ? { liste: [], logo: null, destinataires: null } : await preparerFichiers(extra.docs);
    const messageDevis = [S.message, S.etiq.mot ? `Mot glissé dans chaque colis : « ${S.etiq.mot} »` : ""].filter(Boolean).join("\n\n");
    const contact = extra.contact || S.contact;
    return {
      version: 2,
      id: ids[type] || (ids[type] = nouvelId()),
      duree: Math.round((Date.now() - debut) / 1000),
      siteWeb: extra.siteWeb != null ? extra.siteWeb : ($("#sp2-site-web").value || ""),
      type,
      source: source(),                                       // provenance de la visite (UTM, site d'origine, clic si accord)
      contact: { societe: String(contact.societe || "").trim(), nom: String(contact.nom || "").trim(), email: String(contact.email || "").trim(), telephone: String(contact.telephone || "").trim() },
      entreprise: {
        siret: id.type === "siret" || id.type === "siren" ? id.valeur : "", tva: id.type === "tva" ? id.valeur : "", sansSiret: !!(S.ent.sansSiret || !id.valide),
        bonCommande: S.ent.bc || "",
        facturation: factIdentique() ? { adresse: S.livr.adresse || "", cp: S.livr.cp || "", ville: S.livr.ville || "", pays: "France", identiqueLivraison: true }
          : { adresse: S.ent.adresse || "", cp: S.ent.cp || "", ville: S.ent.ville || "", pays: S.ent.pays || "France", identiqueLivraison: false }
      },
      lignes: S.lignes.map(l => {
        const p = planteDe(l), po = potDeLigne(l);
        const potC = !po ? null : l.mode === "mixpots" ? { mode: "mix" } : { mode: "variant", variantId: po.variantId, sku: po.sku, nom: po.nom };
        if (l.mix) return { mix: true, taille: l.taille, style: l.style || null, plante: { nom: p.nom, taille: l.taille }, pot: potC, qte: l.qte, etiquette: !!l.etiquette, auChoix: false };
        return { mix: false, plante: { variantId: p.variantId, sku: p.sku, nom: p.nom, taille: p.t }, pot: potC, qte: l.qte, etiquette: !!l.etiquette, auChoix: l.mode === "choix" };
      }),
      etiquette: {
        mode: /^logo/.test(t) ? "logo" : "texte",
        titre: AVEC_TITRE.includes(t) ? (S.etiq.titre || "").trim() : "",
        sousTitre: AVEC_SOUS.includes(t) ? (S.etiq.sous || "").trim() : "",
        parDestinataire: !!S.etiq.parDest, logo: f.logo
      },
      livraison: {
        mode: S.livr.mode,
        adresse: S.livr.mode === "une" ? { nom: S.livr.nom || "", adresse: S.livr.adresse || "", cp: S.livr.cp || "", ville: S.livr.ville || "" } : null,
        envois: S.livr.mode === "plusieurs" ? (c.livraison.envois || nbEnvois()) : 1,
        destinataires: f.destinataires,
        dateMode: extra.date != null ? (extra.date ? "precise" : "auPlusVite") : modeDate(),
        dateSouhaitee: extra.date != null ? extra.date : (modeDate() === "auPlusVite" ? "" : S.livr.date),
        dateDebut: extra.date != null ? "" : (modeDate() === "periode" && dateValide(S.livr.dateDebut) ? S.livr.dateDebut : "")
      },
      paiement: paiementEffectif(),
      aConfirmer: aConfirmer(),
      estimation: { totalHT: c.totalHT, taux: c.taux, pieces: c.pieces },
      occasion: S.occasion || "",
      message: extra.message != null ? extra.message : messageDevis,
      fichiers: f.liste
    };
  }
  // Les devis partent d'abord au serveur rapide (Worker Cloudflare, reglage worker_url) : brouillon et lien de paiement
  // en quelques secondes. Sans reponse exploitable (reseau, delai depasse, 503 « indisponible », reponse illisible), la
  // MEME demande (meme id) part au script de reception, qui demande au Worker s'il la connait deja : jamais deux
  // brouillons. Une reponse 200 du Worker fait foi (erreurs de contact et limite comprises, comme celles du script).
  // Sur mesure et rappel : le script directement. Delai : 20 s, plus le temps d'envoyer les fichiers (100 ko par seconde).
  const WORKER = /^https:\/\/[^\s"<>]+$/.test(String(DON.worker || "").trim()) ? String(DON.worker).trim().replace(/\/+$/, "") : "";
  const delaiWorker = octets => 20000 + Math.round(octets / 100);
  async function posterWorker(corps) {
    const arret = new AbortController(), m = setTimeout(() => arret.abort(), delaiWorker(corps.length));
    try {
      const r = await fetch(WORKER + "/devis", { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: corps, signal: arret.signal });
      if (r.status !== 200) return null;
      const rep = await r.json();
      return rep && typeof rep === "object" && typeof rep.ok === "boolean" ? rep : null;
    } catch (e) { return null; }
    finally { clearTimeout(m); }
  }
  // un second essai si le reseau a saute : le script ignore les doublons grace a l'identifiant
  async function poster(corps) {
    let rep = null;
    for (let essai = 0; essai < 2 && !rep; essai++) {
      try {
        const arret = new AbortController(), m = setTimeout(() => arret.abort(), 60000);
        const r = await fetch(DON.reception, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: corps, signal: arret.signal, redirect: "follow" });
        clearTimeout(m);
        rep = await r.json();
      } catch (e) { rep = null; }
    }
    return rep;
  }
  // sans adresse de reception : mode essai, rien ne part, la demande s'affiche dans la console
  async function expedier(corps) {
    if (!DON.reception) {
      console.info("Studio Pro V2 · mode essai : rien n'est envoyé. Demande :\n" + JSON.stringify(corps));
      return { ok: true, essai: true, statut: corps.aConfirmer.length ? "a-confirmer" : "envoye", dossier: "" };
    }
    const texte = JSON.stringify(corps);
    if (WORKER && corps.type === "devis") {
      const rep = await posterWorker(texte);
      if (rep) return rep;
    }
    return poster(texte);
  }
  // ------------------------------------------------ la mesure pub (01/10/2026) : une demande partie = un evenement Shopify
  // « studio_pro_demande », publie apres la reponse positive du serveur, et lu par les pixels personnalises de la boutique
  // (Reglages > Evenements client, autorisation Marketing) : Google Ads, Meta et Microsoft (pub/pixels/). Rien de personnel
  // dedans (ni nom, ni email, ni societe) : le type, le volume, la valeur et le numero de dossier (anti-doublon des regies).
  // Qualifiee : 10 pieces et plus (le tarif pro), ou un projet sur mesure. Valeur : 25 % du total HT estime (une demande
  // sur quatre devient une commande), 175 € pour une demande qualifiee sans estimation (25 % du panier vise de 700 € HT).
  const PAUSE_MESURE = 300;                                   // ms laissees aux pixels avant le depart vers le paiement
  function evenementDemande(type, rep, corps, extra) {
    const est = (corps && corps.estimation) || {};
    const dite = extra && extra.pieces != null ? parseInt((String(extra.pieces).match(/\d+/) || [""])[0], 10) : NaN;
    const pieces = Math.max(0, isFinite(dite) && dite > 0 ? dite : Math.round(Number(est.pieces) || 0));
    const totalHT = Math.max(0, Math.round(Number(est.totalHT) || 0)) / 100;          // centimes -> euros
    const qualifiee = type === "sur-mesure" || pieces >= MIN_PRO;
    return {
      type, pieces, totalHT, qualifiee,
      valeur: totalHT > 0 ? Math.round(totalHT * 25) / 100 : (qualifiee ? 175 : 0), devise: "EUR",
      paiement: type === "devis" ? (corps.paiement || "") : "",
      statut: (rep && rep.statut) || (corps && corps.aConfirmer && corps.aConfirmer.length ? "a-confirmer" : "envoye"),
      dossier: String((rep && rep.dossier) || ""), essai: !!(rep && rep.essai)
    };
  }
  function mesurer(type, rep, corps, extra) {
    try {
      const an = window.Shopify && window.Shopify.analytics;
      if (!an || typeof an.publish !== "function") return false;
      an.publish("studio_pro_demande", evenementDemande(type, rep, corps, extra));
      return true;
    } catch (e) { return false; }                             // la mesure ne bloque jamais une demande
  }
  function erreurEnvoi(zone, texte) {
    const z = $(zone);
    const corps = encodeURIComponent(blocsRecap(calcul()).map(([, t, v]) => `${t} :\n${v}`).join("\n\n"));
    z.innerHTML = `${ech(texte)} <a href="mailto:${ech(EMAIL)}?subject=${encodeURIComponent("Demande Studio Pro")}&body=${corps}">écrivez-nous</a>.`;
    z.hidden = false;
    z.scrollIntoView({ block: "center", behavior: calme ? "auto" : "smooth" });     // jamais un message hors de l'ecran
  }
  let envoiEnCours = false, minuteurEmail = null;
  // Point 1 du strategie (strateges/v2/paiement_rapide.md) : « rien ne bouge apres Payer ». Des le clic (synchrone, bien
  // sous 300 ms), le bouton clique passe en attente ; la barre du telephone, la colonne de l'ordinateur et le bouton du
  // recapitulatif se verrouillent ensemble, avec les retours ; un bandeau a l'ecran dit ce qui se passe, et a 25 s ajoute
  // que le lien part aussi par email. On n'abandonne jamais : si le lien arrive ensuite, la redirection se fait quand meme.
  const VERROUS = "#sp2-envoyer, #sp2-r-go, #sp2-b-go, #sp2-devis-email, #sp2-r-retour, #sp2-b-retour, [data-precedent], [data-modifier], .fil button";
  function placerBandeau() {                // au-dessus de la barre du telephone quand elle est a l'ecran
    const z = $("#sp2-attente-envoi"), barre = $("#sp2-barre");
    const h = barre && barre.classList.contains("montre") && getComputedStyle(barre).display !== "none" ? barre.offsetHeight : 0;
    z.style.bottom = h ? `${h + 12}px` : "";
  }
  function attenteEnvoi(clique, payer) {
    racine.classList.add("sp2-envoi");
    $$(VERROUS).forEach(b => { b.disabled = true; });
    if (clique) { clique.dataset.libelle = clique.textContent; clique.classList.add("attente"); clique.textContent = payer ? "Préparation…" : "Envoi…"; }
    const z = $("#sp2-attente-envoi"), ze = $("#sp2-attente-email");
    z.hidden = false; ze.hidden = true;
    $("#sp2-attente-titre").textContent = payer ? "Préparation de votre paiement sécurisé…" : "Envoi de votre demande…";
    placerBandeau();
    clearTimeout(minuteurEmail);
    if (payer) minuteurEmail = setTimeout(() => { ze.textContent = "Votre lien de paiement vous est aussi envoyé par email."; ze.hidden = false; placerBandeau(); }, 25000);
  }
  function finAttente() {
    clearTimeout(minuteurEmail);
    racine.classList.remove("sp2-envoi");
    $$(".attente[data-libelle]").forEach(b => { b.textContent = b.dataset.libelle; delete b.dataset.libelle; b.classList.remove("attente"); });
    $$(VERROUS).forEach(b => { b.disabled = false; });
    $("#sp2-attente-envoi").hidden = true;
    majBoutonsGo();
  }
  // retour arriere depuis la page de paiement (cache du navigateur) : la page revient deverrouillee
  addEventListener("pageshow", e => { if (e.persisted && racine.classList.contains("sp2-envoi")) finAttente(); });
  // choix « email » : le devis seulement, ecran de fin (avec « Payer par carte » si le lien est la) ; sinon, carte et
  // rien a confirmer : le lien de paiement du brouillon, dans le meme onglet (jamais de nouvel onglet : bloqueurs).
  // clique : le bouton touche (barre, colonne ou recapitulatif), c'est lui qui passe en attente.
  async function envoyer(choix, clique) {
    if (envoiEnCours) return;
    $("#sp2-erreur").hidden = true;
    if (pieces() < MIN_ENVOI) {
      aller("selection");
      const n = $("#sp2-reste"); n.hidden = false; n.textContent = "Ajoutez au moins une plante.";
      return;
    }
    if (!coordonneesValides(false)) { aller("coordonnees", { retour: true }); coordonneesValides(true); return; }
    const payer = choix !== "email" && payerParCarte();
    if (payer && etiquetteEnAttente()) { montrerChoixEtiquette(); return; }          // point 6 : jamais payer sans avoir choisi
    envoiEnCours = true;
    attenteEnvoi(clique || (choix === "email" ? $("#sp2-devis-email") : $("#sp2-envoyer")), payer);
    let corps = null, rep = null;
    try { corps = await charge("devis"); rep = await expedier(corps); }
    catch (e) { rep = null; }
    envoiEnCours = false;
    if (rep && rep.ok) {
      const lien = lienPaiement(rep);
      if (payer && lien) {                                   // tout reste verrouille : la page part vers le paiement
        viderBrouillon(); clearTimeout(minuteurEmail);
        $("#sp2-attente-titre").textContent = "Ouverture du paiement sécurisé…";
        // la demande est comptee avant le depart, avec une courte pause pour laisser partir l'evenement des pixels
        const mesure = mesurer("devis", rep, corps);
        setTimeout(() => { location.href = lien; }, mesure ? PAUSE_MESURE : 0);
        return;
      }
      finAttente(); finir(rep, corps); return;
    }
    finAttente();
    if (rep && rep.erreur === "contact") { aller("coordonnees", { retour: true }); coordonneesValides(true); return; }
    if (rep && rep.erreur === "limite") { erreurEnvoi("#sp2-erreur", "Plusieurs demandes dans l'heure :"); return; }
    erreurEnvoi("#sp2-erreur", "Envoi impossible pour le moment. Réessayez, ou");
  }
  // seulement un vrai lien https renvoye par le script (rien d'autre n'est suivi)
  const lienPaiement = rep => (rep && typeof rep.lienPaiement === "string" && /^https:\/\/[^\s"<>]+$/.test(rep.lienPaiement) ? rep.lienPaiement : "");
  function viderBrouillon() { clearTimeout(minuteurGarde); delete ids.devis; try { localStorage.removeItem(CLE); } catch (e) {} }
  function finir(rep, corps) {
    // Point 3 du strategie : « en-cours » = la meme demande (meme id) est deja en traitement chez le script, qui la
    // termine et envoie tout par email. Jamais de faux « notre equipe vous confirme » dans ce cas.
    const enCours = rep.statut === "en-cours";
    const confirmer = !enCours && (rep.statut === "a-confirmer" || (!rep.statut && corps.aConfirmer.length > 0));
    const lien = confirmer ? "" : lienPaiement(rep);
    const email = corps.contact.email;
    $("#sp2-fin-payer").hidden = !lien; $("#sp2-fin-payer-lien").href = lien || "#";
    $("#sp2-t-fin").textContent = confirmer ? "Notre équipe vous confirme sous 24 h ouvrées" : "Votre devis arrive dans votre boîte mail";
    $("#sp2-fin-texte").textContent = confirmer ? `Réponse sur ${email}.`
      : !enCours ? `Envoyé à ${email}, valable 15 jours.`
      : corps.aConfirmer.length ? `Réponse sur ${email}.`
      : corps.paiement === "carte" ? `Votre devis et son lien de paiement arrivent sur ${email}.` : `Votre devis arrive sur ${email}.`;
    const dz = $("#sp2-fin-dossier");
    dz.hidden = !rep.dossier; dz.textContent = rep.dossier ? `Dossier ${rep.dossier}` : "";
    $("#sp2-fin-essai").hidden = !rep.essai;
    mesurer("devis", rep, corps);
    viderBrouillon();
    aller("fin");
  }
  $("#sp2-nouvelle").onclick = () => { try { localStorage.removeItem(CLE); } catch (e) {} S = ETAT0(); location.hash = "configurateur"; location.reload(); };     // l'adresse #configurateur rouvre le panneau

  // ================================================= FENETRE : SUR MESURE OU PARLER A NOTRE EQUIPE
  const fen = $("#sp2-fenetre");
  let fenMode = "sur-mesure", fenDocs = [], fenEnvoi = false;
  const FM = k => $("#sp2-fm-" + k);
  function resumeComposition() {
    if (!S.lignes.length) return "";
    const c = calcul();
    return blocsRecap(c).filter(([k, t]) => t !== "Coordonnées" && t !== "Règlement").map(([, t, v]) => `${t} : ${v}`).join("\n") + `\nEstimation : ${eurHT(c.totalHT)} pour ${c.pieces} ${pl(c.pieces, "pièce")}`;
  }
  function ouvrirFenetre(mode) {
    if (!fen) return;
    fenMode = mode === "rappel" ? "rappel" : "sur-mesure";
    const sm = fenMode === "sur-mesure";
    $("#sp2-f-sur").textContent = sm ? "Projet sur mesure" : "Parler à notre équipe";
    $("#sp2-f-titre").textContent = sm ? "Votre projet" : "Notre équipe vous rappelle";
    { const r = $("#sp2-fm-tel-requis"); if (r) r.hidden = sm; }
    $("#sp2-f-intro").textContent = "Réponse sous 24 h ouvrées.";
    $("#sp2-fm-projet-l").innerHTML = sm ? "Votre projet" : "Votre question <span>(facultatif)</span>";
    $$("#sp2-fenetre [data-mode]").forEach(el => { el.hidden = el.dataset.mode !== fenMode; });
    [["societe", "societe"], ["nom", "nom"], ["email", "email"], ["telephone", "telephone"]].forEach(([k, s]) => { if (!FM(k).value) FM(k).value = S.contact[s] || ""; });
    if (!FM("quantite").value && pieces()) FM("quantite").value = pieces();
    if (!FM("date").value && modeDate() !== "auPlusVite") FM("date").value = S.livr.date;
    FM("date").min = aujourdhui();
    const rc = resumeComposition();
    $("#sp2-fm-compose").hidden = !rc;
    $("#sp2-fm-compose-texte").textContent = rc;
    $("#sp2-f-contenu").hidden = false; $("#sp2-f-merci").hidden = true; $("#sp2-f-erreur").hidden = true;
    $$("#sp2-fenetre .champ.erreur").forEach(c => c.classList.remove("erreur"));
    if (typeof fen.showModal === "function") { if (!fen.open) fen.showModal(); } else fen.setAttribute("open", "");
  }
  const fermerFenetre = () => { if (typeof fen.close === "function" && fen.open) fen.close(); else fen.removeAttribute("open"); };
  racine.addEventListener("click", e => { const b = e.target.closest("[data-sp2-ouvrir]"); if (b) { e.preventDefault(); if (tiroir.open) fermerTiroir(); ouvrirFenetre(b.dataset.sp2Ouvrir); } });
  if (fen) {
    $("#sp2-f-fermer").onclick = fermerFenetre; $("#sp2-f-ok").onclick = fermerFenetre;
    fen.addEventListener("click", e => { if (e.target === fen) fermerFenetre(); });
    // ce qui est saisi dans la fenetre sert aussi au configurateur, et l'inverse
    [["societe", "societe"], ["nom", "nom"], ["email", "email"], ["telephone", "telephone"]].forEach(([k, s]) => FM(k).addEventListener("input", () => {
      S.contact[s] = FM(k).value; const cible = $("#sp2-" + s); if (cible) cible.value = FM(k).value; garder();
      const c = FM(k).closest(".champ"); if (c) c.classList.remove("erreur");
    }));
    FM("projet").addEventListener("input", () => FM("projet").closest(".champ").classList.remove("erreur"));
    FM("docs").addEventListener("change", e => {
      fenDocs = [...(e.target.files || [])];
      const total = fenDocs.reduce((s, f) => s + f.size, 0);
      $("#sp2-fm-docs-liste").textContent = fenDocs.length ? `${fenDocs.map(f => f.name).join(", ")}${total > 20 * 1048576 ? " · au-delà de 20 Mo, par email" : ""}` : "";
      $("#sp2-fm-docs-zone").innerHTML = fenDocs.length ? `<b>${fenDocs.length} ${pl(fenDocs.length, "document")}</b><br>Remplacer` : `<b>Déposer</b><br>20 Mo au plus`;
    });
    $("#sp2-f-envoyer").onclick = async () => {
      if (fenEnvoi) return;
      const v = k => String(FM(k).value || "").trim();
      let ok = true, premier = null;
      const verif = (k, cond) => { const c = $("#sp2-fc-" + k); c.classList.toggle("erreur", !cond); if (!cond) { FM(k).setAttribute("aria-invalid", "true"); if (!premier) premier = FM(k); } else FM(k).removeAttribute("aria-invalid"); ok = ok && cond; };
      verif("societe", !!v("societe")); verif("nom", !!v("nom")); verif("email", emailValide(v("email")));
      if (fenMode === "sur-mesure") verif("projet", v("projet").length >= 10); else $("#sp2-fc-projet").classList.remove("erreur");
      if ($("#sp2-fc-telephone")) {
        if (fenMode === "rappel" && !/email/i.test(v("creneau"))) verif("telephone", v("telephone").replace(/\D/g, "").length >= 9);
        else { $("#sp2-fc-telephone").classList.remove("erreur"); FM("telephone").removeAttribute("aria-invalid"); }
      }
      if (!ok) { premier.focus(); return; }
      fenEnvoi = true;
      const b = $("#sp2-f-envoyer"); b.disabled = true; b.textContent = "Envoi…";
      const message = fenMode === "sur-mesure"
        ? [v("projet"), v("quantite") ? `Nombre de cadeaux : ${v("quantite")}` : "", v("date") ? `Livraison souhaitée : ${dateLongue(v("date"))}` : ""].filter(Boolean).join("\n")
        : [`Rappel souhaité : ${v("creneau").toLowerCase()}.`, v("projet")].filter(Boolean).join("\n");
      let corps = null, rep = null;
      try {
        corps = await charge(fenMode, { docs: fenMode === "sur-mesure" ? fenDocs : [], message, date: fenMode === "sur-mesure" ? v("date") : undefined, siteWeb: v("site-web"),
          contact: { societe: v("societe"), nom: v("nom"), email: v("email"), telephone: v("telephone") } });
        rep = await expedier(corps);
      } catch (e) { rep = null; }
      fenEnvoi = false; b.disabled = false; b.textContent = "Envoyer";
      if (rep && rep.ok) {
        mesurer(fenMode, rep, corps, fenMode === "sur-mesure" ? { pieces: v("quantite") } : null);
        delete ids[fenMode];
        const email = v("email"), parEmail = /email/i.test(v("creneau"));
        $("#sp2-f-merci-titre").textContent = fenMode === "sur-mesure" ? "Projet bien reçu." : (parEmail ? "Notre équipe vous répond par email." : "Notre équipe vous rappelle.");
        $("#sp2-f-merci-texte").textContent = (rep.dossier ? `Dossier ${rep.dossier}. ` : "") + "Sous 24 h ouvrées.";
        $("#sp2-f-essai").hidden = !rep.essai;
        $("#sp2-f-contenu").hidden = true; $("#sp2-f-merci").hidden = false; $("#sp2-f-merci-titre").focus();
        return;
      }
      const z = $("#sp2-f-erreur");
      z.innerHTML = `${rep && rep.erreur === "limite" ? "Plusieurs messages dans l'heure :" : "Envoi impossible pour le moment. Réessayez, ou"} <a href="mailto:${ech(EMAIL)}?subject=${encodeURIComponent(fenMode === "sur-mesure" ? "Projet sur mesure" : "Studio Pro")}&body=${encodeURIComponent(message + "\n\n" + resumeComposition())}">écrivez-nous</a>.`;
      z.hidden = false;
    };
    // ouverture par l'adresse : les pages voisines (amenagement d'espace) pointent sur #projet-sur-mesure
    const parAdresse = () => { if (location.hash === "#projet-sur-mesure" && !fen.open) ouvrirFenetre("sur-mesure"); };
    parAdresse();
    addEventListener("hashchange", parAdresse);
  }

  // ================================================= ANIMATIONS ET BOUTONS FLOTTANTS (repris de la page actuelle)
  (() => {
    if (calme || !("IntersectionObserver" in window)) return;
    racine.classList.add("sp-anim");
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("vu"); io.unobserve(e.target); } }), { threshold: .12, rootMargin: "0px 0px -6% 0px" });
    $$("[data-reveal], [data-reveal-groupe]").forEach(el => io.observe(el));
    const couches = $$("[data-parallax]");
    let prevu = false;
    const bouger = () => {
      prevu = false;
      const h = window.innerHeight;
      couches.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > h + 200) return;
        const y = Math.max(-140, Math.min(140, (h / 2 - (r.top + r.height / 2)) * parseFloat(el.dataset.parallax || 0)));
        el.style.translate = `0 ${y.toFixed(1)}px`;
      });
    };
    window.addEventListener("scroll", () => { if (!prevu) { prevu = true; requestAnimationFrame(bouger); } }, { passive: true });
    window.addEventListener("resize", bouger, { passive: true });
    bouger();
  })();
  (() => {
    const z = $("#sp2-pictos");
    if (!z || calme || !("IntersectionObserver" in window)) return;
    z.classList.add("pret");
    const o = new IntersectionObserver(es => {
      es.filter(e => !e.isIntersecting).forEach(e => { e.target.classList.remove("vu"); e.target.style.removeProperty("--r"); });
      es.filter(e => e.isIntersecting && e.intersectionRatio >= .35 && !e.target.classList.contains("vu"))
        .sort((a, b) => a.target.style.getPropertyValue("--i") - b.target.style.getPropertyValue("--i"))
        .forEach((e, k) => { e.target.style.setProperty("--r", `${k * .18}s`); e.target.classList.add("vu"); });
    }, { threshold: [0, .35] });
    z.querySelectorAll(".picto").forEach(p => o.observe(p));
  })();
  (() => {
    const m = $(".mosaique");
    if (!m || !m.children.length) return;
    const points = document.createElement("div");
    points.className = "points"; points.setAttribute("aria-hidden", "true");
    points.innerHTML = [...m.children].map(() => "<i></i>").join("");
    m.after(points);
    let prevu = false;
    const maj = () => {
      prevu = false;
      const centre = m.scrollLeft + m.clientWidth / 2;
      let i = 0, ecart = Infinity;
      [...m.children].forEach((f, k) => { const d = Math.abs(f.offsetLeft + f.offsetWidth / 2 - centre); if (d < ecart) { ecart = d; i = k; } });
      points.querySelectorAll("i").forEach((p, k) => p.classList.toggle("actif", k === i));
    };
    m.addEventListener("scroll", () => { if (!prevu) { prevu = true; requestAnimationFrame(maj); } }, { passive: true });
    maj();
  })();
  function ouvrirConfig(defiler) {
    const conf = $("#configurateur");
    S.ouvert = true; garder();
    $("#sp2-config-corps").hidden = false; conf.classList.add("ouvert");
    $("#sp2-ouvrir-config").setAttribute("aria-expanded", "true");
    majBarre();
    if (S.voie === "mix") rendreMix();
    if (defiler) {
      conf.scrollIntoView({ behavior: calme ? "auto" : "smooth", block: "start" });
      const h = $(".etape.active h3"); if (h) setTimeout(() => h.focus({ preventScroll: true }), calme ? 0 : 500);
    }
  }
  racine.addEventListener("click", e => { const b = e.target.closest("[data-ouvrir-config]"); if (!b) return; e.preventDefault(); ouvrirConfig(true); });
  (() => {
    // bouton collant (telephone) : une fois le haut de page passe, tant que le configurateur est replie ;
    // barre du total : visible sur le configurateur ouvert
    const cta = $("#sp2-cta-flottant"), hero = $(".hero"), conf = $("#configurateur"), barre = $("#sp2-barre");
    if (!("IntersectionObserver" in window)) { barre.classList.add("montre"); return; }
    let apresHero = false, surConf = false;
    const maj = () => { cta.classList.toggle("montre", apresHero && !S.ouvert); barre.classList.toggle("montre", surConf && S.ouvert && S.etape !== "fin"); };
    majBarre = maj;
    new IntersectionObserver(e => { apresHero = !e[0].isIntersecting; maj(); }).observe(hero);
    new IntersectionObserver(e => { surConf = e[0].isIntersecting; maj(); }, { threshold: 0 }).observe(conf);
  })();

  // ================================================= LE STOCK EN LIGNE (01/10/2026, Charles)
  // Le stock du Studio est celui du lieu « BY CHARLOT Factory », jamais la boutique Legendre. Le Liquid ne donne que le
  // total des lieux : des l'ouverture, le stock Factory lu par le Worker (GET {worker}/stock, garde une minute) le remplace.
  // Sans reponse (Worker coupe, lent, refus) : le stock du Liquid reste ; le script juge de toute facon au devis.
  async function chargerStockFactory() {
    if (!WORKER || typeof fetch !== "function") return false;
    const arret = typeof AbortController === "function" ? new AbortController() : null;
    const minuteur = arret ? setTimeout(() => arret.abort(), 5000) : null;
    try {
      const r = await fetch(WORKER + "/stock", { method: "GET", credentials: "omit", signal: arret ? arret.signal : undefined });
      if (!r.ok) return false;
      const j = await r.json();
      if (!j || j.ok !== true || !j.stock || typeof j.stock !== "object") return false;
      let change = false;
      (DON.plantes || []).concat(DON.pots || []).forEach(p => {
        const n = p && j.stock[String(p.variantId)];
        if (typeof n === "number" && isFinite(n) && n >= 0 && n !== p.stock) { p.stock = n; change = true; }
      });
      if (change) {
        PLANTES_VUES = PLANTES.filter(p => p.stock >= STOCK_MIN);
        rendrePrix(); rendrePlantes(); toutRendre();
      }
      racine.dataset.stock = "factory";
      return true;
    } catch (e) { return false; }
    finally { if (minuteur) clearTimeout(minuteur); }
  }

  // ================================================= DEMARRAGE
  rendrePrix(); rendreTailles(); rendreVoie(); toutRendre();
  chargerStockFactory();
  // le configurateur s'ouvre de lui-meme pour une selection en cours ou une adresse qui le vise
  if (reprise || S.ouvert || /^#(configurateur|demande)$/.test(location.hash)) ouvrirConfig(/^#(configurateur|demande)$/.test(location.hash));
  addEventListener("hashchange", () => { if (/^#(configurateur|demande)$/.test(location.hash)) ouvrirConfig(true); });
  if (reprise) {
    $("#sp2-reprise").hidden = false;
    if (lignesPerdues) $("#sp2-reprise span").textContent = `Sélection reprise (${lignesPerdues} ${pl(lignesPerdues, "ligne")} ${pl(lignesPerdues, "retirée")}).`;
  }
  $("#sp2-recommencer").onclick = () => { try { localStorage.removeItem(CLE); } catch (e) {} location.hash = "configurateur"; location.reload(); };
  aller(S.etape || "selection", { silence: true });
  window.StudioProV2 = { etat: () => JSON.parse(JSON.stringify(S)), calcul, aConfirmer, charge,
    manques: () => manques().map(m => ({ type: m.type, id: m.item.variantId, nom: m.item.nom, demande: m.demande, dispo: m.dispo, garde: m.garde })) };
})();
